const assessmentReviews = [
    {
        "uuid": "1",
        "no": "A21080201",
        "customerNo": "0001",
        "customerName": "源天然股份有限公司",
        "assessmentPlace":"台東廠",
        "appType": "initial",
        "applyStandard": "tseyue",
        "meetingDate": "2021-11-25T08:20:10.000Z",
        "projectManager": "陳小小",
        "phase": "assessmentReview",
        "activity": "assessmentReview_S30",
        "inspectionContent":{
            "standard":"leezen",
            "inspectionItems":[
                {"productionLine":"line1", "products":["Natural Benefits 食安生技-椰子汁"]},
                {"productionLine":"line2", "products":["杏仁玄米餅","核桃酥"]}
            ],
            "inspectionScope":"評鑑產品之評鑑場所場區環境與衛生管理、製程與品質管制、原料查驗、相關檢驗報告與紀錄表單核對等，及前次所列查驗重點之執行狀況確認",
            "manufacturingProcess": "製程......\n......\n......\n......"
        },
        "inspectionResult":{
            "previousNcrs":[
                {
                    "appNo":"A20080111",
                    "type":"secondary",
                    "inspectionItem":"03-3",
                    "observationDesc":"碳酸鈣550g/包,未涵蓋使用範圍",
                    "status": "improved",
                    "comments": "說明......"
                },
                {
                    "appNo":"A20080111",
                    "type":"secondary",
                    "inspectionItem":"06-1",
                    "observationDesc":"評鑑產品之評鑑場所場區環境與衛生管理、製程與品質管制",
                    "status": "notImproved",
                    "comments": "說明......"
                }
            ],
            "productChangeInspection": "品變編號說明......",
            "otherSupplement": "漏開缺失說明......",
            "leezenRawMaterials":[
                {
                    "id":"1",
                    "type":"material",
                    "name":"豆蓉粉(新版)",
                    "storageCondition":"roomTemperature",
                    "composition":"水、非基因改造脫脂黃豆片、小麥、食鹽、轉化液糖(蔗糖、水)、調味劑(DL-蘋果酸)",
                    "domesticVendor":"穎昌食品有限公司(新和美)",
                    "importer":"",
                    "manufacturer":"穎昌食品有限公司(新和美)",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "addRatio":9,
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":1,
                    "validityAndSituation":"有效日期：2022/03/19(此批非里仁使用)",
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"2",
                    "type":"material",
                    "name":"美國加州杏仁果",
                    "storageCondition":"roomTemperature",
                    "composition":"樹薯澱粉、水(原料)",
                    "domesticVendor":"信成股份有限公司",
                    "importer":"信成股份有限公司",
                    "manufacturer":"TERRA NOVA TRADING INC.",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":2,
                    "validityAndSituation":"有效日期：2023/04/18",
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"3",
                    "name":"美國加州杏仁果",
                    "storageCondition":"refrigeration",
                    "composition":"植物油脂(菜籽油)、洋蔥、葡萄糖、抗氧化劑(維生素C、混合濃縮生育醇)",
                    "domesticVendor":"爾邦得有限公司",
                    "importer":"爾邦得有限公司",
                    "manufacturer":"TERRA NOVA TRADING INC.",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":3,
                    "validityAndSituation":"槽車運送日期2021/09/14(保存期限3個月)，平均約1個月左右進貨一次，\n" +
                        "當天使用有效日期2021.11.17(8/17進貨)",
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"4",
                    "name":"美國加州杏仁果",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"信和股份有限公司",
                    "importer":"信和股份有限公司",
                    "manufacturer":"RPAC,LLC",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":4,
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"5",
                    "name":"美國加州杏仁果",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"信和股份有限公司",
                    "importer":"信和股份有限公司",
                    "manufacturer":"VANN FAMLLY ORCHARDS",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":5,
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"6",
                    "name":"甜扁桃仁粒",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"成久旺股份有限公司",
                    "importer":"成久旺股份有限公司",
                    "manufacturer":"TWIN COMMODITIES,INC.",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":6,
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"7",
                    "name":"帶皮杏仁粒",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"昇祥股份有限公司",
                    "importer":"昇祥股份有限公司",
                    "manufacturer":"美國加州皮爾農場公司",
                    "originPlace":"美國加州",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":7,
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"8",
                    "name":"有機生糙米粉(台灣)",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"青田農產有限公司",
                    "importer":"",
                    "manufacturer":"青田農產有限公司",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":8,
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"9",
                    "name":"精製椰子油",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"禾發實業有限公司",
                    "importer":"禾發實業有限公司",
                    "manufacturer":"OLEO-FATS, INCORPORATED",
                    "originPlace":"菲律賓",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":9,
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"10",
                    "name":"杏仁細粉",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"迦得貿易實業有限公司",
                    "importer":"迦得貿易實業有限公司",
                    "manufacturer":"Treehouse California Almonds LLC",
                    "originPlace":"菲律賓",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":10,
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"11",
                    "name":"杏仁粉(細)",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"成久旺股份有限公司",
                    "importer":"成久旺股份有限公司",
                    "manufacturer":"Treehouse California Almonds LLC",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":11,
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"12",
                    "name":"混合濃縮生育醇",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"信意企業股份有限公司",
                    "importer":"信意企業股份有限公司",
                    "manufacturer":"CARGILL INCORPORATED",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"衛部添製字第002764號/TFAA1N002764004",
                    "processingAid":"N",
                    "accessory":"N",
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                }
            ],
            "tseyueRawMaterials":[
                {
                    "id":"1",
                    "type":"material",
                    "name":"玉米粉",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"乖乖",
                    "importer":"",
                    "manufacturer":"乖乖",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "addRatio":9,
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":1,
                    "validityAndSituation":"有效日期：2022/3/15",
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"2",
                    "type":"material",
                    "name":"精製特砂",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"台糖",
                    "manufacturer":"台糖",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":2,
                    "validityAndSituation":"有效日期：2023/04/18",
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"3",
                    "name":"二次精製軟棕油",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"福懋油脂",
                    "manufacturer":"福懋油脂",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":3,
                    "validityAndSituation":"有效日期：2023/07/09",
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                }
            ]
        },
        "addedNcrs":[
            {
                "itemCode": "1.3",
                "observation": "建立品質保證系統並制定監造計畫，並落實執行現場施工品質抽查驗",
                "nextInspectionFocus": true,
                "reviewResult": "correct",
                "comment": "未落實執行現場施工品質抽查驗",
            }
        ],
        "previousNcrs":[
            {
                "appNo":"A20080111",
                "type":"secondary",
                "inspectionItem":"3.3",
                "ncrDesc":"碳酸鈣550g/包,未涵蓋使用範圍",
                "inspectorConfirmImprovement": "improved",
                "inspectorDesc": "稽核員說明......",
                "reviewerImplementationStatuses": [
                    {"reviewer": "委員1", "implementationStatus": "improved", "reviewDesc": "審查說明 審查說明 審查說明 審查說明 "},
                    {"reviewer": "委員2", "implementationStatus": "notImproved", "reviewDesc": "審查說明 審查說明 審查說明 審查說明 "},
                    {"reviewer": "委員3", "implementationStatus": "noNeedTrack", "reviewDesc": "審查說明 審查說明 審查說明 審查說明 "},
                ],
            },
            {
                "appNo":"A20080111",
                "type":"secondary",
                "inspectionItem":"6.1",
                "ncrDesc":"評鑑產品之評鑑場所場區環境與衛生管理、製程與品質管制",
                "inspectorConfirmImprovement": "notImproved",
                "inspectorDesc": "稽核員說明......",
                "reviewerImplementationStatuses": [
                    {"reviewer": "委員1", "implementationStatus": "improved", "reviewDesc": "審查說明 審查說明 審查說明 審查說明 "},
                    {"reviewer": "委員2", "implementationStatus": "notImproved", "reviewDesc": "審查說明 審查說明 審查說明 審查說明 "},
                    {"reviewer": "委員3", "implementationStatus": "noNeedTrack", "reviewDesc": "審查說明 審查說明 審查說明 審查說明 "},
                ],
            }
        ],
        "inspectionItems":[
            {
                "section":"01",
                "items":[
                    {
                        "itemCode":"1.1",
                        "result":"Y",
                        "observation":"全面品質管理的運作主要是利用計劃、實施、查核及改善的管理循環模式，加以落實。",
                        "createNcr":true,
                        "carNo":"INS01-01"
                    },
                    {
                        "itemCode":"1.2",
                        "result":"N",
                        "observation":"建立品質保證系統並制定監造計畫，並落實執行現場施工品質抽查驗",
                        "createNcr":true,
                        "carNo":"INS01-02"
                    },
                    {
                        "itemCode":"1.3",
                        "result":"Y",
                    },
                    {
                        "itemCode":"1.4",
                        "result":"notApplicable"
                    },
                    {
                        "itemCode":"1.5",
                    }
                ]
            },
            {
                "section":"02",
                "items":[
                    {
                        "itemCode":"2.1",
                        "result":"Y"
                    },
                    {
                        "itemCode":"2.2",
                        "result":"Y"
                    },
                    {
                        "itemCode":"2.3",
                        "result":"N"
                    },
                    {
                        "itemCode":"2.4",
                        "result":"Y"
                    },
                    {
                        "itemCode":"2.5",
                    }
                ]
            },
            {
                "section":"03",
                "items":[
                    {
                        "itemCode":"3.1"
                    },
                    {
                        "itemCode":"3.2"
                    },
                    {
                        "itemCode":"3.3"
                    },
                    {
                        "itemCode":"3.4"
                    },
                    {
                        "itemCode":"3.5"
                    },
                    {
                        "itemCode":"3.6",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.7",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.8",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.9",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.10",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.11",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.12",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.13",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.14"
                    }
                ]
            },
            {
                "section":"04",
                "items":[
                    {
                        "itemCode":"4.1"
                    },
                    {
                        "itemCode":"4.2"
                    },
                    {
                        "itemCode":"4.3"
                    },
                    {
                        "itemCode":"4.4"
                    },
                    {
                        "itemCode":"4.5"
                    },
                    {
                        "itemCode":"4.6"
                    },
                    {
                        "itemCode":"4.7"
                    },
                    {
                        "itemCode":"4.8"
                    },
                    {
                        "itemCode":"4.9"
                    },
                    {
                        "itemCode":"4.10"
                    },
                    {
                        "itemCode":"4.11"
                    },
                    {
                        "itemCode":"4.12"
                    },
                    {
                        "itemCode":"4.13"
                    },
                    {
                        "itemCode":"4.14"
                    },
                    {
                        "itemCode":"4.15"
                    },
                    {
                        "itemCode":"4.16"
                    },
                    {
                        "itemCode":"4.17"
                    },
                ]
            },
            {
                "section":"05",
                "items":[
                    {
                        "itemCode":"5.1"
                    },
                    {
                        "itemCode":"5.2"
                    },
                    {
                        "itemCode":"5.3"
                    },
                    {
                        "itemCode":"5.4"
                    },
                    {
                        "itemCode":"5.5"
                    },
                    {
                        "itemCode":"5.6"
                    },
                    {
                        "itemCode":"5.7"
                    },
                    {
                        "itemCode":"5.8"
                    },
                    {
                        "itemCode":"5.9"
                    },
                    {
                        "itemCode":"5.10"
                    },
                ]
            },
            {
                "section":"06",
                "items":[
                    {
                        "itemCode":"6.1"
                    },
                    {
                        "itemCode":"6.2"
                    },
                    {
                        "itemCode":"6.3"
                    },
                    {
                        "itemCode":"6.4"
                    },
                    {
                        "itemCode":"6.5"
                    },
                    {
                        "itemCode":"6.6"
                    },
                    {
                        "itemCode":"6.7"
                    },
                    {
                        "itemCode":"6.8"
                    },
                    {
                        "itemCode":"6.9"
                    },
                    {
                        "itemCode":"6.10"
                    },
                    {
                        "itemCode":"6.11"
                    },
                    {
                        "itemCode":"6.12"
                    },
                    {
                        "itemCode":"6.13"
                    },
                    {
                        "itemCode":"6.14"
                    },
                    {
                        "itemCode":"6.15"
                    },
                    {
                        "itemCode":"6.16"
                    },
                    {
                        "itemCode":"6.17"
                    },
                    {
                        "itemCode":"6.18"
                    },
                    {
                        "itemCode":"6.19"
                    },
                    {
                        "itemCode":"6.20"
                    },
                ]
            },
            {
                "section":"07",
                "items":[
                    {
                        "itemCode":"7.1"
                    },
                    {
                        "itemCode":"7.2"
                    },
                    {
                        "itemCode":"7.3"
                    },
                    {
                        "itemCode":"7.4"
                    },
                    {
                        "itemCode":"7.5"
                    },
                    {
                        "itemCode":"7.6"
                    },
                    {
                        "itemCode":"7.7"
                    },
                    {
                        "itemCode":"7.8"
                    },
                    {
                        "itemCode":"7.9"
                    }
                ]
            },
            {
                "section":"08",
                "items":[
                    {
                        "itemCode":"8.1"
                    },
                    {
                        "itemCode":"8.2"
                    },
                    {
                        "itemCode":"8.3"
                    },
                    {
                        "itemCode":"8.4"
                    },
                    {
                        "itemCode":"8.5"
                    },
                    {
                        "itemCode":"8.6"
                    },
                    {
                        "itemCode":"8.7"
                    },
                    {
                        "itemCode":"8.8"
                    },
                    {
                        "itemCode":"8.9"
                    },
                    {
                        "itemCode":"8.10"
                    },
                    {
                        "itemCode":"8.11"
                    },
                    {
                        "itemCode":"8.12"
                    },
                    {
                        "itemCode":"8.13"
                    },
                    {
                        "itemCode":"8.14"
                    },
                    {
                        "itemCode":"8.15"
                    },
                    {
                        "itemCode":"8.16"
                    },
                    {
                        "itemCode":"8.17"
                    }
                ]
            },
            {
                "section":"09",
                "items":[
                    {
                        "itemCode":"9.1"
                    },
                    {
                        "itemCode":"9.2"
                    },
                    {
                        "itemCode":"9.3"
                    },
                ]
            }
        ],
        "sampleInfos":[
            {
                "product":"01",
                "testType":"finishedGood",
                "testName":"杏仁玄米餅",
                "finishedGoodTestName":"杏仁玄米餅",
                "testItems":[{testItem:"01"},{testItem:"02", details:["0201","0202"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"台東廠",
                "originPlace":"台灣",
                "testResult":"qualified",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-12-31T08:20:10.000Z",
                "packingSpec":"200g/盒",
                "lotNo":"2019-08-03-2",
                "model":"LC-2K004"
            },
            {
                "product":"03",
                "testType":"rawMaterial",
                "testName":"桂圓四物飲-原料1",
                "rawMaterialTestName":"01",
                "testItems":[{testItem:"01"},{testItem:"03", details:["0301","0303"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"原料1製造商",
                "originPlace":"美國",
                "testResult":"unqualified",
                "unqualifiedReason":"賽滅寧0.5PPM(0.1PPM)",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-09-13T08:20:10.000Z",
                "lotNo":"2018007",
                "model":"HFT-40"
            }
        ],
        "reviewerConclusions":[
            {"reviewer":"王小明","reviewConclusion":"approve"},
            {"reviewer":"王大同","reviewConclusion":"improvement"},
        ],
        "improvementWeeks":3,
        "followUpRequests":[
            {
                "carNo":"INS01-01",
                "ncrType":"primary",
                "checkItems":["02-1","04-2"],
                "observation":"廠外環境污染源現況與申請資料描述不一致",
                "nextInspectionFocus":true,
                "reviewResult":"correct",
                "reviewersOpinions":[
                    {
                        "reviewer":"王小明",
                        "nextInspectionFocus":true,
                        "reviewResult":"correct",
                        "comment":"Gurman 並且稱該頭戴裝置「最快 2022」年可以到來，而且未來蘋果也會推出「單純 AR」的機種，但那要再多等幾年才會來臨了"
                    },
                    {
                        "reviewer":"王大同",
                        "nextInspectionFocus":true,
                        "reviewResult":"correct",
                        "comment":"眾人在期待的，更多還是蘋果能不能利用其格外強大的產品開發與行銷能力，將 MR 帶進主流"
                    }
                ],
                "ncrs":{
                    "type":"secondary",
                    "no":"INS01-01",
                    "itemCode": "1.1",
                    "observationDesc":"碳酸鈣99.95 Suprapur®. REACH(歐盟關於化學品註 ... 建議的貯存溫度, 看產品標籤",
                    "nextInspectionFocus":true,
                    "referencedRegulations":["里仁細則5.10","里仁細則6.2.1"],
                    "ncImprovement":"online",
                    "correctionActionPlan":"由工程主辦機關(監造單位)建立品質保證系統,當監測發現CCP點失控或偏離管制界限時，需要採取矯正措施的行動，確保任何不安全的食品都能被攔除",
                    "evaluateCorrectiveAction":"agree",
                    "evaluateContent":"確認已改善",
                    "reviewResults":[],
                },
            },
            {
                "carNo":"INS01-02",
                "ncrType":"secondary",
                "checkItems":["03-1"],
                "observation":"客戶提供之評鑑場所平面圖與實際看到者不一致",
                "nextInspectionFocus":true,
                "reviewResult":"track",
                "reviewersOpinions":[
                    {
                        "reviewer":"王小明",
                        "nextInspectionFocus":true,
                        "reviewResult":"track",
                        "comment":"Gurman 並且稱該頭戴裝置「最快 2022」年可以到來，而且未來蘋果也會推出「單純 AR」的機種，但那要再多等幾年才會來臨了"
                    },
                    {
                        "reviewer":"王大同",
                        "nextInspectionFocus":true,
                        "reviewResult":"track",
                        "comment":"眾人在期待的，更多還是蘋果能不能利用其格外強大的產品開發與行銷能力，將 MR 帶進主流"
                    }
                ],
                "ncrs": {
                    "type": "secondary",
                    "no": "INS01-01",
                    "itemCode": "1.1",
                    "observationDesc": "碳酸鈣99.95 Suprapur®. REACH(歐盟關於化學品註 ... 建議的貯存溫度, 看產品標籤",
                    "nextInspectionFocus": true,
                    "referencedRegulations": ["里仁細則5.10", "里仁細則6.2.1"],
                    "ncImprovement": "online",
                    "correctionActionPlan": "由工程主辦機關(監造單位)建立品質保證系統,當監測發現CCP點失控或偏離管制界限時，需要採取矯正措施的行動，確保任何不安全的食品都能被攔除",
                    "evaluateCorrectiveAction": "agree",
                    "evaluateContent": "確認已改善",
                    "reviewResults": [],
                },
            },
            {
                "carNo":"INS01-03",
                "ncrType":"secondary",
                "checkItems":["06-1","06-2"],
                "observation":"原料相關證明文件或檢驗報告可與使用原料來源沒有勾稽",
                "reviewersOpinions":[
                    {
                        "reviewer":"王小明",
                        "nextInspectionFocus":true,
                        "reviewResult":"track",
                        "comment":"Gurman 並且稱該頭戴裝置「最快 2022」年可以到來，而且未來蘋果也會推出「單純 AR」的機種，但那要再多等幾年才會來臨了"
                    },
                    {
                        "reviewer":"王大同",
                        "reviewResult":"correct",
                        "comment":"眾人在期待的，更多還是蘋果能不能利用其格外強大的產品開發與行銷能力，將 MR 帶進主流"
                    }
                ],
                "ncrs":{
                    "type":"secondary",
                    "no":"INS01-02",
                    "itemCode": "1.2",
                    "observationDesc":"實衛生管理工作，確保產品在良好環境下產製，使食品品質及其安定性等各項管制作. 業得以有效進行。",
                    "nextInspectionFocus":true,
                    "correctionActionPlan":"核項目及觀察注意事項，評鑑結果應能顯示全數合格及缺失改善完成",
                    "referencedRegulations":["里仁細則5.10","慈悅第三部分 評鑑作業流程3.3.1"],
                    "ncImprovement":"online",
                    "evaluateCorrectiveAction":"agree",
                    "evaluateContent":"確認已改善",
                    "reviewResults":[],
                },
            },
            {
                "checkItems":["06-3"],
                "ncrType":"secondary",
                "observation":"原材料進貨時沒有驗收紀錄",
                "nextInspectionFocus":true,
                "reviewResult":"track",
                "reviewersOpinions":[
                    {
                        "reviewer":"王小明",
                        "nextInspectionFocus":true,
                        "reviewResult":"track",
                        "comment":"Gurman 並且稱該頭戴裝置「最快 2022」年可以到來，而且未來蘋果也會推出「單純 AR」的機種，但那要再多等幾年才會來臨了"
                    },
                ],
                "ncrs":{
                    "type":"secondary",
                    "no":"INS01-03",
                    "itemCode": "1.3",
                    "observationDesc":"程序書提供範例僅供參考，其中的條件、頻率或數字應以業者實際操作流程而適當 ... 目的:為建立本廠醬油產品製程及品質管制作業程序。",
                    "nextInspectionFocus":true,
                    "referencedRegulations":["GHP附表一.一.(三)"],
                    "ncImprovement":"online",
                    "correctionActionPlan":"稽核完成後，由食品安全決策小組召集稽核人員及受稽核單位，舉行結束會議，請稽核人員對稽核缺失進行報告，受稽核單位對稽核報告確認無誤，雙方當場於稽核查檢紀錄表簽字，受稽核單位於一個月內回覆內部稽核異常處理紀錄表。",
                    "evaluateCorrectiveAction":"improve",
                    "evaluateContent":"規劃再確認輸入食品衛生安全之流程，必要時進行矯正措施或修訂食品安全監測計畫",
                    "reviewResults":[],
                },
            }
        ],
        "otherAttentions":[
            {"otherAttention":"武陵農場一年一度的櫻花季，將在明年2月12日登場，11月1日早上8點半，開放散客預約住宿，短短5分鐘將近2000間的房間，全被預訂一空", "reviewer":"王小明"},
            {"otherAttention":"多選用新鮮食品，配料及調味料需留意有效期限及保存條件，不使用來路不明的食材，也要避免剩餘菜餚反覆加熱食用", "reviewer":"王大同"}
        ],
        "addSampleInfos":[
            {
                "product":"01",
                "testType":"finishedGood",
                "testName":"杏仁玄米餅",
                "finishedGoodTestName":"杏仁玄米餅",
                "testItems":[{testItem:"01"},{testItem:"02", details:["0201","0202"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"台東廠",
                "originPlace":"台灣",
                "testResult":"qualified",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-12-31T08:20:10.000Z",
                "packingSpec":"200g/盒",
                "lotNo":"2019-08-03-2",
                "model":"LC-2K004"
            },
            {
                "product":"03",
                "testType":"rawMaterial",
                "testName":"桂圓四物飲-原料1",
                "rawMaterialTestName":"01",
                "testItems":[{testItem:"01"},{testItem:"03", details:["0301","0303"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"原料1製造商",
                "originPlace":"美國",
                "testResult":"unqualified",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-09-13T08:20:10.000Z",
                "lotNo":"2018007",
                "model":"HFT-40"
            }
        ],
    },
    {
        "uuid": "2",
        "no": "A21080202",
        "customerNo": "0002",
        "customerName": "豆之家食品科技股份有限公司",
        "assessmentPlace":"台東廠",
        "appType": "initial",
        "applyStandard": "leezen",
        "meetingDate": "2021-11-25T08:20:10.000Z",
        "projectManager": "陳小小",
        "phase": "assessmentReview",
        "activity": "assessmentReview_S30",
        "inspectionContent":{
            "standard":"leezen",
            "inspectionItems":[
                {"productionLine":"line1", "products":["Natural Benefits 食安生技-椰子汁"]},
                {"productionLine":"line2", "products":["杏仁玄米餅","核桃酥"]}
            ],
            "inspectionScope":"評鑑產品之評鑑場所場區環境與衛生管理、製程與品質管制、原料查驗、相關檢驗報告與紀錄表單核對等，及前次所列查驗重點之執行狀況確認",
            "manufacturingProcess": "製程......\n......\n......\n......"
        },
        "inspectionResult":{
            "previousNcrs":[
                {
                    "appNo":"A20080111",
                    "type":"secondary",
                    "inspectionItem":"03-3",
                    "observationDesc":"碳酸鈣550g/包,未涵蓋使用範圍",
                    "status": "improved",
                    "comments": "說明......"
                },
                {
                    "appNo":"A20080111",
                    "type":"secondary",
                    "inspectionItem":"06-1",
                    "observationDesc":"評鑑產品之評鑑場所場區環境與衛生管理、製程與品質管制",
                    "status": "notImproved",
                    "comments": "說明......"
                }
            ],
            "productChangeInspection": "品變編號說明......",
            "otherSupplement": "漏開缺失說明......",
            "leezenRawMaterials":[
                {
                    "id":"1",
                    "type":"material",
                    "name":"豆蓉粉(新版)",
                    "storageCondition":"roomTemperature",
                    "composition":"水、非基因改造脫脂黃豆片、小麥、食鹽、轉化液糖(蔗糖、水)、調味劑(DL-蘋果酸)",
                    "domesticVendor":"穎昌食品有限公司(新和美)",
                    "importer":"",
                    "manufacturer":"穎昌食品有限公司(新和美)",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "addRatio":9,
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":1,
                    "validityAndSituation":"有效日期：2022/03/19(此批非里仁使用)",
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"2",
                    "type":"material",
                    "name":"美國加州杏仁果",
                    "storageCondition":"roomTemperature",
                    "composition":"樹薯澱粉、水(原料)",
                    "domesticVendor":"信成股份有限公司",
                    "importer":"信成股份有限公司",
                    "manufacturer":"TERRA NOVA TRADING INC.",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":2,
                    "validityAndSituation":"有效日期：2023/04/18",
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"3",
                    "name":"美國加州杏仁果",
                    "storageCondition":"refrigeration",
                    "composition":"植物油脂(菜籽油)、洋蔥、葡萄糖、抗氧化劑(維生素C、混合濃縮生育醇)",
                    "domesticVendor":"爾邦得有限公司",
                    "importer":"爾邦得有限公司",
                    "manufacturer":"TERRA NOVA TRADING INC.",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":3,
                    "validityAndSituation":"槽車運送日期2021/09/14(保存期限3個月)，平均約1個月左右進貨一次，\n" +
                        "當天使用有效日期2021.11.17(8/17進貨)",
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"4",
                    "name":"美國加州杏仁果",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"信和股份有限公司",
                    "importer":"信和股份有限公司",
                    "manufacturer":"RPAC,LLC",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":4,
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"5",
                    "name":"美國加州杏仁果",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"信和股份有限公司",
                    "importer":"信和股份有限公司",
                    "manufacturer":"VANN FAMLLY ORCHARDS",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":5,
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"6",
                    "name":"甜扁桃仁粒",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"成久旺股份有限公司",
                    "importer":"成久旺股份有限公司",
                    "manufacturer":"TWIN COMMODITIES,INC.",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":6,
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"7",
                    "name":"帶皮杏仁粒",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"昇祥股份有限公司",
                    "importer":"昇祥股份有限公司",
                    "manufacturer":"美國加州皮爾農場公司",
                    "originPlace":"美國加州",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":7,
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"8",
                    "name":"有機生糙米粉(台灣)",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"青田農產有限公司",
                    "importer":"",
                    "manufacturer":"青田農產有限公司",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":8,
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"9",
                    "name":"精製椰子油",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"禾發實業有限公司",
                    "importer":"禾發實業有限公司",
                    "manufacturer":"OLEO-FATS, INCORPORATED",
                    "originPlace":"菲律賓",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":9,
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"10",
                    "name":"杏仁細粉",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"迦得貿易實業有限公司",
                    "importer":"迦得貿易實業有限公司",
                    "manufacturer":"Treehouse California Almonds LLC",
                    "originPlace":"菲律賓",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":10,
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"11",
                    "name":"杏仁粉(細)",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"成久旺股份有限公司",
                    "importer":"成久旺股份有限公司",
                    "manufacturer":"Treehouse California Almonds LLC",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":11,
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"12",
                    "name":"混合濃縮生育醇",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"信意企業股份有限公司",
                    "importer":"信意企業股份有限公司",
                    "manufacturer":"CARGILL INCORPORATED",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"衛部添製字第002764號/TFAA1N002764004",
                    "processingAid":"N",
                    "accessory":"N",
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                }
            ],
            "tseyueRawMaterials":[
                {
                    "id":"1",
                    "type":"material",
                    "name":"玉米粉",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"乖乖",
                    "importer":"",
                    "manufacturer":"乖乖",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "addRatio":9,
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":1,
                    "validityAndSituation":"有效日期：2022/3/15",
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"2",
                    "type":"material",
                    "name":"精製特砂",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"台糖",
                    "manufacturer":"台糖",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":2,
                    "validityAndSituation":"有效日期：2023/04/18",
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"3",
                    "name":"二次精製軟棕油",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"福懋油脂",
                    "manufacturer":"福懋油脂",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":3,
                    "validityAndSituation":"有效日期：2023/07/09",
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                }
            ]
        },
        "addedNcrs":[
            {
                "itemCode": "1.3",
                "observation": "建立品質保證系統並制定監造計畫，並落實執行現場施工品質抽查驗",
                "nextInspectionFocus": true,
                "reviewResult": "correct",
                "comment": "未落實執行現場施工品質抽查驗",
            }
        ],
        "previousNcrs":[
            {
                "appNo":"A20080111",
                "type":"secondary",
                "inspectionItem":"3.3",
                "ncrDesc":"碳酸鈣550g/包,未涵蓋使用範圍",
                "inspectorConfirmImprovement": "improved",
                "inspectorDesc": "稽核員說明......",
                "reviewerImplementationStatuses": [
                    {"reviewer": "委員1", "implementationStatus": "improved", "reviewDesc": "審查說明 審查說明 審查說明 審查說明 "},
                    {"reviewer": "委員2", "implementationStatus": "notImproved", "reviewDesc": "審查說明 審查說明 審查說明 審查說明 "},
                    {"reviewer": "委員3", "implementationStatus": "noNeedTrack", "reviewDesc": "審查說明 審查說明 審查說明 審查說明 "},
                ],
            },
            {
                "appNo":"A20080111",
                "type":"secondary",
                "inspectionItem":"6.1",
                "ncrDesc":"評鑑產品之評鑑場所場區環境與衛生管理、製程與品質管制",
                "inspectorConfirmImprovement": "notImproved",
                "inspectorDesc": "稽核員說明......",
                "reviewerImplementationStatuses": [
                    {"reviewer": "委員1", "implementationStatus": "improved", "reviewDesc": "審查說明 審查說明 審查說明 審查說明 "},
                    {"reviewer": "委員2", "implementationStatus": "notImproved", "reviewDesc": "審查說明 審查說明 審查說明 審查說明 "},
                    {"reviewer": "委員3", "implementationStatus": "noNeedTrack", "reviewDesc": "審查說明 審查說明 審查說明 審查說明 "},
                ],
            }
        ],
        "inspectionItems":[
            {
                "section":"01",
                "items":[
                    {
                        "itemCode":"1.1",
                        "result":"Y",
                        "observation":"全面品質管理的運作主要是利用計劃、實施、查核及改善的管理循環模式，加以落實。",
                        "createNcr":true,
                        "carNo":"INS01-01"
                    },
                    {
                        "itemCode":"1.2",
                        "result":"N",
                        "observation":"建立品質保證系統並制定監造計畫，並落實執行現場施工品質抽查驗",
                        "createNcr":true,
                        "carNo":"INS01-02"
                    },
                    {
                        "itemCode":"1.3",
                        "result":"Y",
                    },
                    {
                        "itemCode":"1.4",
                        "result":"notApplicable"
                    },
                    {
                        "itemCode":"1.5",
                    }
                ]
            },
            {
                "section":"02",
                "items":[
                    {
                        "itemCode":"2.1",
                        "result":"Y"
                    },
                    {
                        "itemCode":"2.2",
                        "result":"Y"
                    },
                    {
                        "itemCode":"2.3",
                        "result":"N"
                    },
                    {
                        "itemCode":"2.4",
                        "result":"Y"
                    },
                    {
                        "itemCode":"2.5",
                    }
                ]
            },
            {
                "section":"03",
                "items":[
                    {
                        "itemCode":"3.1"
                    },
                    {
                        "itemCode":"3.2"
                    },
                    {
                        "itemCode":"3.3"
                    },
                    {
                        "itemCode":"3.4"
                    },
                    {
                        "itemCode":"3.5"
                    },
                    {
                        "itemCode":"3.6",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.7",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.8",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.9",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.10",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.11",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.12",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.13",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.14"
                    }
                ]
            },
            {
                "section":"04",
                "items":[
                    {
                        "itemCode":"4.1"
                    },
                    {
                        "itemCode":"4.2"
                    },
                    {
                        "itemCode":"4.3"
                    },
                    {
                        "itemCode":"4.4"
                    },
                    {
                        "itemCode":"4.5"
                    },
                    {
                        "itemCode":"4.6"
                    },
                    {
                        "itemCode":"4.7"
                    },
                    {
                        "itemCode":"4.8"
                    },
                    {
                        "itemCode":"4.9"
                    },
                    {
                        "itemCode":"4.10"
                    },
                    {
                        "itemCode":"4.11"
                    },
                    {
                        "itemCode":"4.12"
                    },
                    {
                        "itemCode":"4.13"
                    },
                    {
                        "itemCode":"4.14"
                    },
                    {
                        "itemCode":"4.15"
                    },
                    {
                        "itemCode":"4.16"
                    },
                    {
                        "itemCode":"4.17"
                    },
                ]
            },
            {
                "section":"05",
                "items":[
                    {
                        "itemCode":"5.1"
                    },
                    {
                        "itemCode":"5.2"
                    },
                    {
                        "itemCode":"5.3"
                    },
                    {
                        "itemCode":"5.4"
                    },
                    {
                        "itemCode":"5.5"
                    },
                    {
                        "itemCode":"5.6"
                    },
                    {
                        "itemCode":"5.7"
                    },
                    {
                        "itemCode":"5.8"
                    },
                    {
                        "itemCode":"5.9"
                    },
                    {
                        "itemCode":"5.10"
                    },
                ]
            },
            {
                "section":"06",
                "items":[
                    {
                        "itemCode":"6.1"
                    },
                    {
                        "itemCode":"6.2"
                    },
                    {
                        "itemCode":"6.3"
                    },
                    {
                        "itemCode":"6.4"
                    },
                    {
                        "itemCode":"6.5"
                    },
                    {
                        "itemCode":"6.6"
                    },
                    {
                        "itemCode":"6.7"
                    },
                    {
                        "itemCode":"6.8"
                    },
                    {
                        "itemCode":"6.9"
                    },
                    {
                        "itemCode":"6.10"
                    },
                    {
                        "itemCode":"6.11"
                    },
                    {
                        "itemCode":"6.12"
                    },
                    {
                        "itemCode":"6.13"
                    },
                    {
                        "itemCode":"6.14"
                    },
                    {
                        "itemCode":"6.15"
                    },
                    {
                        "itemCode":"6.16"
                    },
                    {
                        "itemCode":"6.17"
                    },
                    {
                        "itemCode":"6.18"
                    },
                    {
                        "itemCode":"6.19"
                    },
                    {
                        "itemCode":"6.20"
                    },
                ]
            },
            {
                "section":"07",
                "items":[
                    {
                        "itemCode":"7.1"
                    },
                    {
                        "itemCode":"7.2"
                    },
                    {
                        "itemCode":"7.3"
                    },
                    {
                        "itemCode":"7.4"
                    },
                    {
                        "itemCode":"7.5"
                    },
                    {
                        "itemCode":"7.6"
                    },
                    {
                        "itemCode":"7.7"
                    },
                    {
                        "itemCode":"7.8"
                    },
                    {
                        "itemCode":"7.9"
                    }
                ]
            },
            {
                "section":"08",
                "items":[
                    {
                        "itemCode":"8.1"
                    },
                    {
                        "itemCode":"8.2"
                    },
                    {
                        "itemCode":"8.3"
                    },
                    {
                        "itemCode":"8.4"
                    },
                    {
                        "itemCode":"8.5"
                    },
                    {
                        "itemCode":"8.6"
                    },
                    {
                        "itemCode":"8.7"
                    },
                    {
                        "itemCode":"8.8"
                    },
                    {
                        "itemCode":"8.9"
                    },
                    {
                        "itemCode":"8.10"
                    },
                    {
                        "itemCode":"8.11"
                    },
                    {
                        "itemCode":"8.12"
                    },
                    {
                        "itemCode":"8.13"
                    },
                    {
                        "itemCode":"8.14"
                    },
                    {
                        "itemCode":"8.15"
                    },
                    {
                        "itemCode":"8.16"
                    },
                    {
                        "itemCode":"8.17"
                    }
                ]
            },
            {
                "section":"09",
                "items":[
                    {
                        "itemCode":"9.1"
                    },
                    {
                        "itemCode":"9.2"
                    },
                    {
                        "itemCode":"9.3"
                    },
                ]
            }
        ],
        "sampleInfos":[
            {
                "product":"01",
                "testType":"finishedGood",
                "testName":"杏仁玄米餅",
                "finishedGoodTestName":"杏仁玄米餅",
                "testItems":[{testItem:"01"},{testItem:"02", details:["0201","0202"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"台東廠",
                "originPlace":"台灣",
                "testResult":"qualified",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-12-31T08:20:10.000Z",
                "packingSpec":"200g/盒",
                "lotNo":"2019-08-03-2",
                "model":"LC-2K004"
            },
            {
                "product":"03",
                "testType":"rawMaterial",
                "testName":"桂圓四物飲-原料1",
                "rawMaterialTestName":"01",
                "testItems":[{testItem:"01"},{testItem:"03", details:["0301","0303"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"原料1製造商",
                "originPlace":"美國",
                "testResult":"unqualified",
                "unqualifiedReason":"賽滅寧0.5PPM(0.1PPM)",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-09-13T08:20:10.000Z",
                "lotNo":"2018007",
                "model":"HFT-40"
            }
        ],
        "reviewerConclusions":[
            {"reviewer":"王小明","reviewConclusion":"approve"},
            {"reviewer":"王大同","reviewConclusion":"improvement"},
        ],
        "improvementWeeks":3,
        "followUpRequests":[
            {
                "carNo":"INS01-01",
                "ncrType":"primary",
                "checkItems":["02-1","04-2"],
                "observation":"廠外環境污染源現況與申請資料描述不一致",
                "nextInspectionFocus":true,
                "reviewResult":"correct",
                "reviewersOpinions":[
                    {
                        "reviewer":"王小明",
                        "nextInspectionFocus":true,
                        "reviewResult":"correct",
                        "comment":"Gurman 並且稱該頭戴裝置「最快 2022」年可以到來，而且未來蘋果也會推出「單純 AR」的機種，但那要再多等幾年才會來臨了"
                    },
                    {
                        "reviewer":"王大同",
                        "nextInspectionFocus":true,
                        "reviewResult":"correct",
                        "comment":"眾人在期待的，更多還是蘋果能不能利用其格外強大的產品開發與行銷能力，將 MR 帶進主流"
                    }
                ],
                "ncrs":{
                    "type":"secondary",
                    "no":"INS01-01",
                    "itemCode": "1.1",
                    "observationDesc":"碳酸鈣99.95 Suprapur®. REACH(歐盟關於化學品註 ... 建議的貯存溫度, 看產品標籤",
                    "nextInspectionFocus":true,
                    "referencedRegulations":["里仁細則5.10","里仁細則6.2.1"],
                    "ncImprovement":"online",
                    "correctionActionPlan":"由工程主辦機關(監造單位)建立品質保證系統,當監測發現CCP點失控或偏離管制界限時，需要採取矯正措施的行動，確保任何不安全的食品都能被攔除",
                    "evaluateCorrectiveAction":"agree",
                    "evaluateContent":"確認已改善",
                    "reviewResults":[],
                },
            },
            {
                "carNo":"INS01-02",
                "ncrType":"secondary",
                "checkItems":["03-1"],
                "observation":"客戶提供之評鑑場所平面圖與實際看到者不一致",
                "nextInspectionFocus":true,
                "reviewResult":"track",
                "reviewersOpinions":[
                    {
                        "reviewer":"王小明",
                        "nextInspectionFocus":true,
                        "reviewResult":"track",
                        "comment":"Gurman 並且稱該頭戴裝置「最快 2022」年可以到來，而且未來蘋果也會推出「單純 AR」的機種，但那要再多等幾年才會來臨了"
                    },
                    {
                        "reviewer":"王大同",
                        "nextInspectionFocus":true,
                        "reviewResult":"track",
                        "comment":"眾人在期待的，更多還是蘋果能不能利用其格外強大的產品開發與行銷能力，將 MR 帶進主流"
                    }
                ],
                "ncrs": {
                    "type": "secondary",
                    "no": "INS01-01",
                    "itemCode": "1.1",
                    "observationDesc": "碳酸鈣99.95 Suprapur®. REACH(歐盟關於化學品註 ... 建議的貯存溫度, 看產品標籤",
                    "nextInspectionFocus": true,
                    "referencedRegulations": ["里仁細則5.10", "里仁細則6.2.1"],
                    "ncImprovement": "online",
                    "correctionActionPlan": "由工程主辦機關(監造單位)建立品質保證系統,當監測發現CCP點失控或偏離管制界限時，需要採取矯正措施的行動，確保任何不安全的食品都能被攔除",
                    "evaluateCorrectiveAction": "agree",
                    "evaluateContent": "確認已改善",
                    "reviewResults": [],
                },
            },
            {
                "carNo":"INS01-03",
                "ncrType":"secondary",
                "checkItems":["06-1","06-2"],
                "observation":"原料相關證明文件或檢驗報告可與使用原料來源沒有勾稽",
                "reviewersOpinions":[
                    {
                        "reviewer":"王小明",
                        "nextInspectionFocus":true,
                        "reviewResult":"track",
                        "comment":"Gurman 並且稱該頭戴裝置「最快 2022」年可以到來，而且未來蘋果也會推出「單純 AR」的機種，但那要再多等幾年才會來臨了"
                    },
                    {
                        "reviewer":"王大同",
                        "reviewResult":"correct",
                        "comment":"眾人在期待的，更多還是蘋果能不能利用其格外強大的產品開發與行銷能力，將 MR 帶進主流"
                    }
                ],
                "ncrs":{
                    "type":"secondary",
                    "no":"INS01-02",
                    "itemCode": "1.2",
                    "observationDesc":"實衛生管理工作，確保產品在良好環境下產製，使食品品質及其安定性等各項管制作. 業得以有效進行。",
                    "nextInspectionFocus":true,
                    "correctionActionPlan":"核項目及觀察注意事項，評鑑結果應能顯示全數合格及缺失改善完成",
                    "referencedRegulations":["里仁細則5.10","慈悅第三部分 評鑑作業流程3.3.1"],
                    "ncImprovement":"online",
                    "evaluateCorrectiveAction":"agree",
                    "evaluateContent":"確認已改善",
                    "reviewResults":[],
                },
            },
            {
                "checkItems":["06-3"],
                "ncrType":"secondary",
                "observation":"原材料進貨時沒有驗收紀錄",
                "nextInspectionFocus":true,
                "reviewResult":"track",
                "reviewersOpinions":[
                    {
                        "reviewer":"王小明",
                        "nextInspectionFocus":true,
                        "reviewResult":"track",
                        "comment":"Gurman 並且稱該頭戴裝置「最快 2022」年可以到來，而且未來蘋果也會推出「單純 AR」的機種，但那要再多等幾年才會來臨了"
                    },
                ],
                "ncrs":{
                    "type":"secondary",
                    "no":"INS01-03",
                    "itemCode": "1.3",
                    "observationDesc":"程序書提供範例僅供參考，其中的條件、頻率或數字應以業者實際操作流程而適當 ... 目的:為建立本廠醬油產品製程及品質管制作業程序。",
                    "nextInspectionFocus":true,
                    "referencedRegulations":["GHP附表一.一.(三)"],
                    "ncImprovement":"online",
                    "correctionActionPlan":"稽核完成後，由食品安全決策小組召集稽核人員及受稽核單位，舉行結束會議，請稽核人員對稽核缺失進行報告，受稽核單位對稽核報告確認無誤，雙方當場於稽核查檢紀錄表簽字，受稽核單位於一個月內回覆內部稽核異常處理紀錄表。",
                    "evaluateCorrectiveAction":"improve",
                    "evaluateContent":"規劃再確認輸入食品衛生安全之流程，必要時進行矯正措施或修訂食品安全監測計畫",
                    "reviewResults":[],
                },
            }
        ],
        "otherAttentions":[
            {"otherAttention":"武陵農場一年一度的櫻花季，將在明年2月12日登場，11月1日早上8點半，開放散客預約住宿，短短5分鐘將近2000間的房間，全被預訂一空", "reviewer":"王小明"},
            {"otherAttention":"多選用新鮮食品，配料及調味料需留意有效期限及保存條件，不使用來路不明的食材，也要避免剩餘菜餚反覆加熱食用", "reviewer":"王大同"}
        ],
        "addSampleInfos":[
            {
                "product":"01",
                "testType":"finishedGood",
                "testName":"杏仁玄米餅",
                "finishedGoodTestName":"杏仁玄米餅",
                "testItems":[{testItem:"01"},{testItem:"02", details:["0201","0202"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"台東廠",
                "originPlace":"台灣",
                "testResult":"qualified",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-12-31T08:20:10.000Z",
                "packingSpec":"200g/盒",
                "lotNo":"2019-08-03-2",
                "model":"LC-2K004"
            },
            {
                "product":"03",
                "testType":"rawMaterial",
                "testName":"桂圓四物飲-原料1",
                "rawMaterialTestName":"01",
                "testItems":[{testItem:"01"},{testItem:"03", details:["0301","0303"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"原料1製造商",
                "originPlace":"美國",
                "testResult":"unqualified",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-09-13T08:20:10.000Z",
                "lotNo":"2018007",
                "model":"HFT-40"
            }
        ],
    },
    {
        "uuid": "3",
        "no": "A21080203",
        "customerNo": "0003",
        "customerName": "黑松股份有限公司",
        "assessmentPlace":"台東廠",
        "appType": "initial",
        "applyStandard": "tseyue",
        "meetingDate": "2021-11-25T08:20:10.000Z",
        "projectManager": "李阿白",
        "phase": "assessmentReview",
        "activity": "assessmentReview_S30",
        "inspectionContent":{
            "standard":"leezen",
            "inspectionItems":[
                {"productionLine":"line1", "products":["Natural Benefits 食安生技-椰子汁"]},
                {"productionLine":"line2", "products":["杏仁玄米餅","核桃酥"]}
            ],
            "inspectionScope":"評鑑產品之評鑑場所場區環境與衛生管理、製程與品質管制、原料查驗、相關檢驗報告與紀錄表單核對等，及前次所列查驗重點之執行狀況確認",
            "manufacturingProcess": "製程......\n......\n......\n......"
        },
        "inspectionResult":{
            "previousNcrs":[
                {
                    "appNo":"A20080111",
                    "type":"secondary",
                    "inspectionItem":"03-3",
                    "observationDesc":"碳酸鈣550g/包,未涵蓋使用範圍",
                    "status": "improved",
                    "comments": "說明......"
                },
                {
                    "appNo":"A20080111",
                    "type":"secondary",
                    "inspectionItem":"06-1",
                    "observationDesc":"評鑑產品之評鑑場所場區環境與衛生管理、製程與品質管制",
                    "status": "notImproved",
                    "comments": "說明......"
                }
            ],
            "productChangeInspection": "品變編號說明......",
            "otherSupplement": "漏開缺失說明......",
            "leezenRawMaterials":[
                {
                    "id":"1",
                    "type":"material",
                    "name":"豆蓉粉(新版)",
                    "storageCondition":"roomTemperature",
                    "composition":"水、非基因改造脫脂黃豆片、小麥、食鹽、轉化液糖(蔗糖、水)、調味劑(DL-蘋果酸)",
                    "domesticVendor":"穎昌食品有限公司(新和美)",
                    "importer":"",
                    "manufacturer":"穎昌食品有限公司(新和美)",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "addRatio":9,
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":1,
                    "validityAndSituation":"有效日期：2022/03/19(此批非里仁使用)",
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"2",
                    "type":"material",
                    "name":"美國加州杏仁果",
                    "storageCondition":"roomTemperature",
                    "composition":"樹薯澱粉、水(原料)",
                    "domesticVendor":"信成股份有限公司",
                    "importer":"信成股份有限公司",
                    "manufacturer":"TERRA NOVA TRADING INC.",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":2,
                    "validityAndSituation":"有效日期：2023/04/18",
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"3",
                    "name":"美國加州杏仁果",
                    "storageCondition":"refrigeration",
                    "composition":"植物油脂(菜籽油)、洋蔥、葡萄糖、抗氧化劑(維生素C、混合濃縮生育醇)",
                    "domesticVendor":"爾邦得有限公司",
                    "importer":"爾邦得有限公司",
                    "manufacturer":"TERRA NOVA TRADING INC.",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":3,
                    "validityAndSituation":"槽車運送日期2021/09/14(保存期限3個月)，平均約1個月左右進貨一次，\n" +
                        "當天使用有效日期2021.11.17(8/17進貨)",
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"4",
                    "name":"美國加州杏仁果",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"信和股份有限公司",
                    "importer":"信和股份有限公司",
                    "manufacturer":"RPAC,LLC",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":4,
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"5",
                    "name":"美國加州杏仁果",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"信和股份有限公司",
                    "importer":"信和股份有限公司",
                    "manufacturer":"VANN FAMLLY ORCHARDS",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":5,
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"6",
                    "name":"甜扁桃仁粒",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"成久旺股份有限公司",
                    "importer":"成久旺股份有限公司",
                    "manufacturer":"TWIN COMMODITIES,INC.",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":6,
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"7",
                    "name":"帶皮杏仁粒",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"昇祥股份有限公司",
                    "importer":"昇祥股份有限公司",
                    "manufacturer":"美國加州皮爾農場公司",
                    "originPlace":"美國加州",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":7,
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"8",
                    "name":"有機生糙米粉(台灣)",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"青田農產有限公司",
                    "importer":"",
                    "manufacturer":"青田農產有限公司",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":8,
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"9",
                    "name":"精製椰子油",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"禾發實業有限公司",
                    "importer":"禾發實業有限公司",
                    "manufacturer":"OLEO-FATS, INCORPORATED",
                    "originPlace":"菲律賓",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":9,
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"10",
                    "name":"杏仁細粉",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"迦得貿易實業有限公司",
                    "importer":"迦得貿易實業有限公司",
                    "manufacturer":"Treehouse California Almonds LLC",
                    "originPlace":"菲律賓",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":10,
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"11",
                    "name":"杏仁粉(細)",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"成久旺股份有限公司",
                    "importer":"成久旺股份有限公司",
                    "manufacturer":"Treehouse California Almonds LLC",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":11,
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"12",
                    "name":"混合濃縮生育醇",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"信意企業股份有限公司",
                    "importer":"信意企業股份有限公司",
                    "manufacturer":"CARGILL INCORPORATED",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"衛部添製字第002764號/TFAA1N002764004",
                    "processingAid":"N",
                    "accessory":"N",
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                }
            ],
            "tseyueRawMaterials":[
                {
                    "id":"1",
                    "type":"material",
                    "name":"玉米粉",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"乖乖",
                    "importer":"",
                    "manufacturer":"乖乖",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "addRatio":9,
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":1,
                    "validityAndSituation":"有效日期：2022/3/15",
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"2",
                    "type":"material",
                    "name":"精製特砂",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"台糖",
                    "manufacturer":"台糖",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":2,
                    "validityAndSituation":"有效日期：2023/04/18",
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"3",
                    "name":"二次精製軟棕油",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"福懋油脂",
                    "manufacturer":"福懋油脂",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":3,
                    "validityAndSituation":"有效日期：2023/07/09",
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                }
            ]
        },
        "addedNcrs":[
            {
                "itemCode": "1.3",
                "observation": "建立品質保證系統並制定監造計畫，並落實執行現場施工品質抽查驗",
                "nextInspectionFocus": true,
                "reviewResult": "correct",
                "comment": "未落實執行現場施工品質抽查驗",
            }
        ],
        "previousNcrs":[
            {
                "appNo":"A20080111",
                "type":"secondary",
                "inspectionItem":"3.3",
                "ncrDesc":"碳酸鈣550g/包,未涵蓋使用範圍",
                "inspectorConfirmImprovement": "improved",
                "inspectorDesc": "稽核員說明......",
                "reviewerImplementationStatuses": [
                    {"reviewer": "委員1", "implementationStatus": "improved", "reviewDesc": "審查說明 審查說明 審查說明 審查說明 "},
                    {"reviewer": "委員2", "implementationStatus": "notImproved", "reviewDesc": "審查說明 審查說明 審查說明 審查說明 "},
                    {"reviewer": "委員3", "implementationStatus": "noNeedTrack", "reviewDesc": "審查說明 審查說明 審查說明 審查說明 "},
                ],
            },
            {
                "appNo":"A20080111",
                "type":"secondary",
                "inspectionItem":"6.1",
                "ncrDesc":"評鑑產品之評鑑場所場區環境與衛生管理、製程與品質管制",
                "inspectorConfirmImprovement": "notImproved",
                "inspectorDesc": "稽核員說明......",
                "reviewerImplementationStatuses": [
                    {"reviewer": "委員1", "implementationStatus": "improved", "reviewDesc": "審查說明 審查說明 審查說明 審查說明 "},
                    {"reviewer": "委員2", "implementationStatus": "notImproved", "reviewDesc": "審查說明 審查說明 審查說明 審查說明 "},
                    {"reviewer": "委員3", "implementationStatus": "noNeedTrack", "reviewDesc": "審查說明 審查說明 審查說明 審查說明 "},
                ],
            }
        ],
        "inspectionItems":[
            {
                "section":"01",
                "items":[
                    {
                        "itemCode":"1.1",
                        "result":"Y",
                        "observation":"全面品質管理的運作主要是利用計劃、實施、查核及改善的管理循環模式，加以落實。",
                        "createNcr":true,
                        "carNo":"INS01-01"
                    },
                    {
                        "itemCode":"1.2",
                        "result":"N",
                        "observation":"建立品質保證系統並制定監造計畫，並落實執行現場施工品質抽查驗",
                        "createNcr":true,
                        "carNo":"INS01-02"
                    },
                    {
                        "itemCode":"1.3",
                        "result":"Y",
                    },
                    {
                        "itemCode":"1.4",
                        "result":"notApplicable"
                    },
                    {
                        "itemCode":"1.5",
                    }
                ]
            },
            {
                "section":"02",
                "items":[
                    {
                        "itemCode":"2.1",
                        "result":"Y"
                    },
                    {
                        "itemCode":"2.2",
                        "result":"Y"
                    },
                    {
                        "itemCode":"2.3",
                        "result":"N"
                    },
                    {
                        "itemCode":"2.4",
                        "result":"Y"
                    },
                    {
                        "itemCode":"2.5",
                    }
                ]
            },
            {
                "section":"03",
                "items":[
                    {
                        "itemCode":"3.1"
                    },
                    {
                        "itemCode":"3.2"
                    },
                    {
                        "itemCode":"3.3"
                    },
                    {
                        "itemCode":"3.4"
                    },
                    {
                        "itemCode":"3.5"
                    },
                    {
                        "itemCode":"3.6",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.7",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.8",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.9",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.10",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.11",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.12",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.13",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.14"
                    }
                ]
            },
            {
                "section":"04",
                "items":[
                    {
                        "itemCode":"4.1"
                    },
                    {
                        "itemCode":"4.2"
                    },
                    {
                        "itemCode":"4.3"
                    },
                    {
                        "itemCode":"4.4"
                    },
                    {
                        "itemCode":"4.5"
                    },
                    {
                        "itemCode":"4.6"
                    },
                    {
                        "itemCode":"4.7"
                    },
                    {
                        "itemCode":"4.8"
                    },
                    {
                        "itemCode":"4.9"
                    },
                    {
                        "itemCode":"4.10"
                    },
                    {
                        "itemCode":"4.11"
                    },
                    {
                        "itemCode":"4.12"
                    },
                    {
                        "itemCode":"4.13"
                    },
                    {
                        "itemCode":"4.14"
                    },
                    {
                        "itemCode":"4.15"
                    },
                    {
                        "itemCode":"4.16"
                    },
                    {
                        "itemCode":"4.17"
                    },
                ]
            },
            {
                "section":"05",
                "items":[
                    {
                        "itemCode":"5.1"
                    },
                    {
                        "itemCode":"5.2"
                    },
                    {
                        "itemCode":"5.3"
                    },
                    {
                        "itemCode":"5.4"
                    },
                    {
                        "itemCode":"5.5"
                    },
                    {
                        "itemCode":"5.6"
                    },
                    {
                        "itemCode":"5.7"
                    },
                    {
                        "itemCode":"5.8"
                    },
                    {
                        "itemCode":"5.9"
                    },
                    {
                        "itemCode":"5.10"
                    },
                ]
            },
            {
                "section":"06",
                "items":[
                    {
                        "itemCode":"6.1"
                    },
                    {
                        "itemCode":"6.2"
                    },
                    {
                        "itemCode":"6.3"
                    },
                    {
                        "itemCode":"6.4"
                    },
                    {
                        "itemCode":"6.5"
                    },
                    {
                        "itemCode":"6.6"
                    },
                    {
                        "itemCode":"6.7"
                    },
                    {
                        "itemCode":"6.8"
                    },
                    {
                        "itemCode":"6.9"
                    },
                    {
                        "itemCode":"6.10"
                    },
                    {
                        "itemCode":"6.11"
                    },
                    {
                        "itemCode":"6.12"
                    },
                    {
                        "itemCode":"6.13"
                    },
                    {
                        "itemCode":"6.14"
                    },
                    {
                        "itemCode":"6.15"
                    },
                    {
                        "itemCode":"6.16"
                    },
                    {
                        "itemCode":"6.17"
                    },
                    {
                        "itemCode":"6.18"
                    },
                    {
                        "itemCode":"6.19"
                    },
                    {
                        "itemCode":"6.20"
                    },
                ]
            },
            {
                "section":"07",
                "items":[
                    {
                        "itemCode":"7.1"
                    },
                    {
                        "itemCode":"7.2"
                    },
                    {
                        "itemCode":"7.3"
                    },
                    {
                        "itemCode":"7.4"
                    },
                    {
                        "itemCode":"7.5"
                    },
                    {
                        "itemCode":"7.6"
                    },
                    {
                        "itemCode":"7.7"
                    },
                    {
                        "itemCode":"7.8"
                    },
                    {
                        "itemCode":"7.9"
                    }
                ]
            },
            {
                "section":"08",
                "items":[
                    {
                        "itemCode":"8.1"
                    },
                    {
                        "itemCode":"8.2"
                    },
                    {
                        "itemCode":"8.3"
                    },
                    {
                        "itemCode":"8.4"
                    },
                    {
                        "itemCode":"8.5"
                    },
                    {
                        "itemCode":"8.6"
                    },
                    {
                        "itemCode":"8.7"
                    },
                    {
                        "itemCode":"8.8"
                    },
                    {
                        "itemCode":"8.9"
                    },
                    {
                        "itemCode":"8.10"
                    },
                    {
                        "itemCode":"8.11"
                    },
                    {
                        "itemCode":"8.12"
                    },
                    {
                        "itemCode":"8.13"
                    },
                    {
                        "itemCode":"8.14"
                    },
                    {
                        "itemCode":"8.15"
                    },
                    {
                        "itemCode":"8.16"
                    },
                    {
                        "itemCode":"8.17"
                    }
                ]
            },
            {
                "section":"09",
                "items":[
                    {
                        "itemCode":"9.1"
                    },
                    {
                        "itemCode":"9.2"
                    },
                    {
                        "itemCode":"9.3"
                    },
                ]
            }
        ],
        "sampleInfos":[
            {
                "product":"01",
                "testType":"finishedGood",
                "testName":"杏仁玄米餅",
                "finishedGoodTestName":"杏仁玄米餅",
                "testItems":[{testItem:"01"},{testItem:"02", details:["0201","0202"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"台東廠",
                "originPlace":"台灣",
                "testResult":"qualified",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-12-31T08:20:10.000Z",
                "packingSpec":"200g/盒",
                "lotNo":"2019-08-03-2",
                "model":"LC-2K004"
            },
            {
                "product":"03",
                "testType":"rawMaterial",
                "testName":"桂圓四物飲-原料1",
                "rawMaterialTestName":"01",
                "testItems":[{testItem:"01"},{testItem:"03", details:["0301","0303"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"原料1製造商",
                "originPlace":"美國",
                "testResult":"unqualified",
                "unqualifiedReason":"賽滅寧0.5PPM(0.1PPM)",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-09-13T08:20:10.000Z",
                "lotNo":"2018007",
                "model":"HFT-40"
            }
        ],
        "reviewerConclusions":[
            {"reviewer":"王小明","reviewConclusion":"approve"},
            {"reviewer":"王大同","reviewConclusion":"improvement"},
        ],
        "improvementWeeks":3,
        "followUpRequests":[
            {
                "carNo":"INS01-01",
                "ncrType":"primary",
                "checkItems":["02-1","04-2"],
                "observation":"廠外環境污染源現況與申請資料描述不一致",
                "nextInspectionFocus":true,
                "reviewResult":"correct",
                "reviewersOpinions":[
                    {
                        "reviewer":"王小明",
                        "nextInspectionFocus":true,
                        "reviewResult":"correct",
                        "comment":"Gurman 並且稱該頭戴裝置「最快 2022」年可以到來，而且未來蘋果也會推出「單純 AR」的機種，但那要再多等幾年才會來臨了"
                    },
                    {
                        "reviewer":"王大同",
                        "nextInspectionFocus":true,
                        "reviewResult":"correct",
                        "comment":"眾人在期待的，更多還是蘋果能不能利用其格外強大的產品開發與行銷能力，將 MR 帶進主流"
                    }
                ],
                "ncrs":{
                    "type":"secondary",
                    "no":"INS01-01",
                    "itemCode": "1.1",
                    "observationDesc":"碳酸鈣99.95 Suprapur®. REACH(歐盟關於化學品註 ... 建議的貯存溫度, 看產品標籤",
                    "nextInspectionFocus":true,
                    "referencedRegulations":["里仁細則5.10","里仁細則6.2.1"],
                    "ncImprovement":"online",
                    "correctionActionPlan":"由工程主辦機關(監造單位)建立品質保證系統,當監測發現CCP點失控或偏離管制界限時，需要採取矯正措施的行動，確保任何不安全的食品都能被攔除",
                    "evaluateCorrectiveAction":"agree",
                    "evaluateContent":"確認已改善",
                    "reviewResults":[],
                },
            },
            {
                "carNo":"INS01-02",
                "ncrType":"secondary",
                "checkItems":["03-1"],
                "observation":"客戶提供之評鑑場所平面圖與實際看到者不一致",
                "nextInspectionFocus":true,
                "reviewResult":"track",
                "reviewersOpinions":[
                    {
                        "reviewer":"王小明",
                        "nextInspectionFocus":true,
                        "reviewResult":"track",
                        "comment":"Gurman 並且稱該頭戴裝置「最快 2022」年可以到來，而且未來蘋果也會推出「單純 AR」的機種，但那要再多等幾年才會來臨了"
                    },
                    {
                        "reviewer":"王大同",
                        "nextInspectionFocus":true,
                        "reviewResult":"track",
                        "comment":"眾人在期待的，更多還是蘋果能不能利用其格外強大的產品開發與行銷能力，將 MR 帶進主流"
                    }
                ],
                "ncrs": {
                    "type": "secondary",
                    "no": "INS01-01",
                    "itemCode": "1.1",
                    "observationDesc": "碳酸鈣99.95 Suprapur®. REACH(歐盟關於化學品註 ... 建議的貯存溫度, 看產品標籤",
                    "nextInspectionFocus": true,
                    "referencedRegulations": ["里仁細則5.10", "里仁細則6.2.1"],
                    "ncImprovement": "online",
                    "correctionActionPlan": "由工程主辦機關(監造單位)建立品質保證系統,當監測發現CCP點失控或偏離管制界限時，需要採取矯正措施的行動，確保任何不安全的食品都能被攔除",
                    "evaluateCorrectiveAction": "agree",
                    "evaluateContent": "確認已改善",
                    "reviewResults": [],
                },
            },
            {
                "carNo":"INS01-03",
                "ncrType":"secondary",
                "checkItems":["06-1","06-2"],
                "observation":"原料相關證明文件或檢驗報告可與使用原料來源沒有勾稽",
                "reviewersOpinions":[
                    {
                        "reviewer":"王小明",
                        "nextInspectionFocus":true,
                        "reviewResult":"track",
                        "comment":"Gurman 並且稱該頭戴裝置「最快 2022」年可以到來，而且未來蘋果也會推出「單純 AR」的機種，但那要再多等幾年才會來臨了"
                    },
                    {
                        "reviewer":"王大同",
                        "reviewResult":"correct",
                        "comment":"眾人在期待的，更多還是蘋果能不能利用其格外強大的產品開發與行銷能力，將 MR 帶進主流"
                    }
                ],
                "ncrs":{
                    "type":"secondary",
                    "no":"INS01-02",
                    "itemCode": "1.2",
                    "observationDesc":"實衛生管理工作，確保產品在良好環境下產製，使食品品質及其安定性等各項管制作. 業得以有效進行。",
                    "nextInspectionFocus":true,
                    "correctionActionPlan":"核項目及觀察注意事項，評鑑結果應能顯示全數合格及缺失改善完成",
                    "referencedRegulations":["里仁細則5.10","慈悅第三部分 評鑑作業流程3.3.1"],
                    "ncImprovement":"online",
                    "evaluateCorrectiveAction":"agree",
                    "evaluateContent":"確認已改善",
                    "reviewResults":[],
                },
            },
            {
                "checkItems":["06-3"],
                "ncrType":"secondary",
                "observation":"原材料進貨時沒有驗收紀錄",
                "nextInspectionFocus":true,
                "reviewResult":"track",
                "reviewersOpinions":[
                    {
                        "reviewer":"王小明",
                        "nextInspectionFocus":true,
                        "reviewResult":"track",
                        "comment":"Gurman 並且稱該頭戴裝置「最快 2022」年可以到來，而且未來蘋果也會推出「單純 AR」的機種，但那要再多等幾年才會來臨了"
                    },
                ],
                "ncrs":{
                    "type":"secondary",
                    "no":"INS01-03",
                    "itemCode": "1.3",
                    "observationDesc":"程序書提供範例僅供參考，其中的條件、頻率或數字應以業者實際操作流程而適當 ... 目的:為建立本廠醬油產品製程及品質管制作業程序。",
                    "nextInspectionFocus":true,
                    "referencedRegulations":["GHP附表一.一.(三)"],
                    "ncImprovement":"online",
                    "correctionActionPlan":"稽核完成後，由食品安全決策小組召集稽核人員及受稽核單位，舉行結束會議，請稽核人員對稽核缺失進行報告，受稽核單位對稽核報告確認無誤，雙方當場於稽核查檢紀錄表簽字，受稽核單位於一個月內回覆內部稽核異常處理紀錄表。",
                    "evaluateCorrectiveAction":"improve",
                    "evaluateContent":"規劃再確認輸入食品衛生安全之流程，必要時進行矯正措施或修訂食品安全監測計畫",
                    "reviewResults":[],
                },
            }
        ],
        "otherAttentions":[
            {"otherAttention":"武陵農場一年一度的櫻花季，將在明年2月12日登場，11月1日早上8點半，開放散客預約住宿，短短5分鐘將近2000間的房間，全被預訂一空", "reviewer":"王小明"},
            {"otherAttention":"多選用新鮮食品，配料及調味料需留意有效期限及保存條件，不使用來路不明的食材，也要避免剩餘菜餚反覆加熱食用", "reviewer":"王大同"}
        ],
        "addSampleInfos":[
            {
                "product":"01",
                "testType":"finishedGood",
                "testName":"杏仁玄米餅",
                "finishedGoodTestName":"杏仁玄米餅",
                "testItems":[{testItem:"01"},{testItem:"02", details:["0201","0202"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"台東廠",
                "originPlace":"台灣",
                "testResult":"qualified",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-12-31T08:20:10.000Z",
                "packingSpec":"200g/盒",
                "lotNo":"2019-08-03-2",
                "model":"LC-2K004"
            },
            {
                "product":"03",
                "testType":"rawMaterial",
                "testName":"桂圓四物飲-原料1",
                "rawMaterialTestName":"01",
                "testItems":[{testItem:"01"},{testItem:"03", details:["0301","0303"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"原料1製造商",
                "originPlace":"美國",
                "testResult":"unqualified",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-09-13T08:20:10.000Z",
                "lotNo":"2018007",
                "model":"HFT-40"
            }
        ],
    },
    {
        "uuid": "4",
        "no": "A21080204",
        "customerNo": "0004",
        "customerName": "中農粉絲有限公司",
        "assessmentPlace":"台東廠",
        "appType": "expandingLine",
        "applyStandard": "leezen",
        "meetingDate": "2021-11-25T08:20:10.000Z",
        "projectManager": "李阿白",
        "phase": "assessmentReview",
        "activity": "assessmentReview_S30",
        "inspectionContent":{
            "standard":"leezen",
            "inspectionItems":[
                {"productionLine":"line1", "products":["Natural Benefits 食安生技-椰子汁"]},
                {"productionLine":"line2", "products":["杏仁玄米餅","核桃酥"]}
            ],
            "inspectionScope":"評鑑產品之評鑑場所場區環境與衛生管理、製程與品質管制、原料查驗、相關檢驗報告與紀錄表單核對等，及前次所列查驗重點之執行狀況確認",
            "manufacturingProcess": "製程......\n......\n......\n......"
        },
        "inspectionResult":{
            "previousNcrs":[
                {
                    "appNo":"A20080111",
                    "type":"secondary",
                    "inspectionItem":"03-3",
                    "observationDesc":"碳酸鈣550g/包,未涵蓋使用範圍",
                    "status": "improved",
                    "comments": "說明......"
                },
                {
                    "appNo":"A20080111",
                    "type":"secondary",
                    "inspectionItem":"06-1",
                    "observationDesc":"評鑑產品之評鑑場所場區環境與衛生管理、製程與品質管制",
                    "status": "notImproved",
                    "comments": "說明......"
                }
            ],
            "productChangeInspection": "品變編號說明......",
            "otherSupplement": "漏開缺失說明......",
            "leezenRawMaterials":[
                {
                    "id":"1",
                    "type":"material",
                    "name":"豆蓉粉(新版)",
                    "storageCondition":"roomTemperature",
                    "composition":"水、非基因改造脫脂黃豆片、小麥、食鹽、轉化液糖(蔗糖、水)、調味劑(DL-蘋果酸)",
                    "domesticVendor":"穎昌食品有限公司(新和美)",
                    "importer":"",
                    "manufacturer":"穎昌食品有限公司(新和美)",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "addRatio":9,
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":1,
                    "validityAndSituation":"有效日期：2022/03/19(此批非里仁使用)",
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"2",
                    "type":"material",
                    "name":"美國加州杏仁果",
                    "storageCondition":"roomTemperature",
                    "composition":"樹薯澱粉、水(原料)",
                    "domesticVendor":"信成股份有限公司",
                    "importer":"信成股份有限公司",
                    "manufacturer":"TERRA NOVA TRADING INC.",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":2,
                    "validityAndSituation":"有效日期：2023/04/18",
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"3",
                    "name":"美國加州杏仁果",
                    "storageCondition":"refrigeration",
                    "composition":"植物油脂(菜籽油)、洋蔥、葡萄糖、抗氧化劑(維生素C、混合濃縮生育醇)",
                    "domesticVendor":"爾邦得有限公司",
                    "importer":"爾邦得有限公司",
                    "manufacturer":"TERRA NOVA TRADING INC.",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":3,
                    "validityAndSituation":"槽車運送日期2021/09/14(保存期限3個月)，平均約1個月左右進貨一次，\n" +
                        "當天使用有效日期2021.11.17(8/17進貨)",
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"4",
                    "name":"美國加州杏仁果",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"信和股份有限公司",
                    "importer":"信和股份有限公司",
                    "manufacturer":"RPAC,LLC",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":4,
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"5",
                    "name":"美國加州杏仁果",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"信和股份有限公司",
                    "importer":"信和股份有限公司",
                    "manufacturer":"VANN FAMLLY ORCHARDS",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":5,
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"6",
                    "name":"甜扁桃仁粒",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"成久旺股份有限公司",
                    "importer":"成久旺股份有限公司",
                    "manufacturer":"TWIN COMMODITIES,INC.",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":6,
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"7",
                    "name":"帶皮杏仁粒",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"昇祥股份有限公司",
                    "importer":"昇祥股份有限公司",
                    "manufacturer":"美國加州皮爾農場公司",
                    "originPlace":"美國加州",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":7,
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"8",
                    "name":"有機生糙米粉(台灣)",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"青田農產有限公司",
                    "importer":"",
                    "manufacturer":"青田農產有限公司",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":8,
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"9",
                    "name":"精製椰子油",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"禾發實業有限公司",
                    "importer":"禾發實業有限公司",
                    "manufacturer":"OLEO-FATS, INCORPORATED",
                    "originPlace":"菲律賓",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":9,
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"10",
                    "name":"杏仁細粉",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"迦得貿易實業有限公司",
                    "importer":"迦得貿易實業有限公司",
                    "manufacturer":"Treehouse California Almonds LLC",
                    "originPlace":"菲律賓",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":10,
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"11",
                    "name":"杏仁粉(細)",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"成久旺股份有限公司",
                    "importer":"成久旺股份有限公司",
                    "manufacturer":"Treehouse California Almonds LLC",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":11,
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"12",
                    "name":"混合濃縮生育醇",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"信意企業股份有限公司",
                    "importer":"信意企業股份有限公司",
                    "manufacturer":"CARGILL INCORPORATED",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"衛部添製字第002764號/TFAA1N002764004",
                    "processingAid":"N",
                    "accessory":"N",
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                }
            ],
            "tseyueRawMaterials":[
                {
                    "id":"1",
                    "type":"material",
                    "name":"玉米粉",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"乖乖",
                    "importer":"",
                    "manufacturer":"乖乖",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "addRatio":9,
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":1,
                    "validityAndSituation":"有效日期：2022/3/15",
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"2",
                    "type":"material",
                    "name":"精製特砂",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"台糖",
                    "manufacturer":"台糖",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":2,
                    "validityAndSituation":"有效日期：2023/04/18",
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"3",
                    "name":"二次精製軟棕油",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"福懋油脂",
                    "manufacturer":"福懋油脂",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":3,
                    "validityAndSituation":"有效日期：2023/07/09",
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                }
            ]
        },
        "addedNcrs":[
            {
                "itemCode": "1.3",
                "observation": "建立品質保證系統並制定監造計畫，並落實執行現場施工品質抽查驗",
                "nextInspectionFocus": true,
                "reviewResult": "correct",
                "comment": "未落實執行現場施工品質抽查驗",
            }
        ],
        "previousNcrs":[
            {
                "appNo":"A20080111",
                "type":"secondary",
                "inspectionItem":"3.3",
                "ncrDesc":"碳酸鈣550g/包,未涵蓋使用範圍",
                "inspectorConfirmImprovement": "improved",
                "inspectorDesc": "稽核員說明......",
                "reviewerImplementationStatuses": [
                    {"reviewer": "委員1", "implementationStatus": "improved", "reviewDesc": "審查說明 審查說明 審查說明 審查說明 "},
                    {"reviewer": "委員2", "implementationStatus": "notImproved", "reviewDesc": "審查說明 審查說明 審查說明 審查說明 "},
                    {"reviewer": "委員3", "implementationStatus": "noNeedTrack", "reviewDesc": "審查說明 審查說明 審查說明 審查說明 "},
                ],
            },
            {
                "appNo":"A20080111",
                "type":"secondary",
                "inspectionItem":"6.1",
                "ncrDesc":"評鑑產品之評鑑場所場區環境與衛生管理、製程與品質管制",
                "inspectorConfirmImprovement": "notImproved",
                "inspectorDesc": "稽核員說明......",
                "reviewerImplementationStatuses": [
                    {"reviewer": "委員1", "implementationStatus": "improved", "reviewDesc": "審查說明 審查說明 審查說明 審查說明 "},
                    {"reviewer": "委員2", "implementationStatus": "notImproved", "reviewDesc": "審查說明 審查說明 審查說明 審查說明 "},
                    {"reviewer": "委員3", "implementationStatus": "noNeedTrack", "reviewDesc": "審查說明 審查說明 審查說明 審查說明 "},
                ],
            }
        ],
        "inspectionItems":[
            {
                "section":"01",
                "items":[
                    {
                        "itemCode":"1.1",
                        "result":"Y",
                        "observation":"全面品質管理的運作主要是利用計劃、實施、查核及改善的管理循環模式，加以落實。",
                        "createNcr":true,
                        "carNo":"INS01-01"
                    },
                    {
                        "itemCode":"1.2",
                        "result":"N",
                        "observation":"建立品質保證系統並制定監造計畫，並落實執行現場施工品質抽查驗",
                        "createNcr":true,
                        "carNo":"INS01-02"
                    },
                    {
                        "itemCode":"1.3",
                        "result":"Y",
                    },
                    {
                        "itemCode":"1.4",
                        "result":"notApplicable"
                    },
                    {
                        "itemCode":"1.5",
                    }
                ]
            },
            {
                "section":"02",
                "items":[
                    {
                        "itemCode":"2.1",
                        "result":"Y"
                    },
                    {
                        "itemCode":"2.2",
                        "result":"Y"
                    },
                    {
                        "itemCode":"2.3",
                        "result":"N"
                    },
                    {
                        "itemCode":"2.4",
                        "result":"Y"
                    },
                    {
                        "itemCode":"2.5",
                    }
                ]
            },
            {
                "section":"03",
                "items":[
                    {
                        "itemCode":"3.1"
                    },
                    {
                        "itemCode":"3.2"
                    },
                    {
                        "itemCode":"3.3"
                    },
                    {
                        "itemCode":"3.4"
                    },
                    {
                        "itemCode":"3.5"
                    },
                    {
                        "itemCode":"3.6",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.7",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.8",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.9",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.10",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.11",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.12",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.13",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.14"
                    }
                ]
            },
            {
                "section":"04",
                "items":[
                    {
                        "itemCode":"4.1"
                    },
                    {
                        "itemCode":"4.2"
                    },
                    {
                        "itemCode":"4.3"
                    },
                    {
                        "itemCode":"4.4"
                    },
                    {
                        "itemCode":"4.5"
                    },
                    {
                        "itemCode":"4.6"
                    },
                    {
                        "itemCode":"4.7"
                    },
                    {
                        "itemCode":"4.8"
                    },
                    {
                        "itemCode":"4.9"
                    },
                    {
                        "itemCode":"4.10"
                    },
                    {
                        "itemCode":"4.11"
                    },
                    {
                        "itemCode":"4.12"
                    },
                    {
                        "itemCode":"4.13"
                    },
                    {
                        "itemCode":"4.14"
                    },
                    {
                        "itemCode":"4.15"
                    },
                    {
                        "itemCode":"4.16"
                    },
                    {
                        "itemCode":"4.17"
                    },
                ]
            },
            {
                "section":"05",
                "items":[
                    {
                        "itemCode":"5.1"
                    },
                    {
                        "itemCode":"5.2"
                    },
                    {
                        "itemCode":"5.3"
                    },
                    {
                        "itemCode":"5.4"
                    },
                    {
                        "itemCode":"5.5"
                    },
                    {
                        "itemCode":"5.6"
                    },
                    {
                        "itemCode":"5.7"
                    },
                    {
                        "itemCode":"5.8"
                    },
                    {
                        "itemCode":"5.9"
                    },
                    {
                        "itemCode":"5.10"
                    },
                ]
            },
            {
                "section":"06",
                "items":[
                    {
                        "itemCode":"6.1"
                    },
                    {
                        "itemCode":"6.2"
                    },
                    {
                        "itemCode":"6.3"
                    },
                    {
                        "itemCode":"6.4"
                    },
                    {
                        "itemCode":"6.5"
                    },
                    {
                        "itemCode":"6.6"
                    },
                    {
                        "itemCode":"6.7"
                    },
                    {
                        "itemCode":"6.8"
                    },
                    {
                        "itemCode":"6.9"
                    },
                    {
                        "itemCode":"6.10"
                    },
                    {
                        "itemCode":"6.11"
                    },
                    {
                        "itemCode":"6.12"
                    },
                    {
                        "itemCode":"6.13"
                    },
                    {
                        "itemCode":"6.14"
                    },
                    {
                        "itemCode":"6.15"
                    },
                    {
                        "itemCode":"6.16"
                    },
                    {
                        "itemCode":"6.17"
                    },
                    {
                        "itemCode":"6.18"
                    },
                    {
                        "itemCode":"6.19"
                    },
                    {
                        "itemCode":"6.20"
                    },
                ]
            },
            {
                "section":"07",
                "items":[
                    {
                        "itemCode":"7.1"
                    },
                    {
                        "itemCode":"7.2"
                    },
                    {
                        "itemCode":"7.3"
                    },
                    {
                        "itemCode":"7.4"
                    },
                    {
                        "itemCode":"7.5"
                    },
                    {
                        "itemCode":"7.6"
                    },
                    {
                        "itemCode":"7.7"
                    },
                    {
                        "itemCode":"7.8"
                    },
                    {
                        "itemCode":"7.9"
                    }
                ]
            },
            {
                "section":"08",
                "items":[
                    {
                        "itemCode":"8.1"
                    },
                    {
                        "itemCode":"8.2"
                    },
                    {
                        "itemCode":"8.3"
                    },
                    {
                        "itemCode":"8.4"
                    },
                    {
                        "itemCode":"8.5"
                    },
                    {
                        "itemCode":"8.6"
                    },
                    {
                        "itemCode":"8.7"
                    },
                    {
                        "itemCode":"8.8"
                    },
                    {
                        "itemCode":"8.9"
                    },
                    {
                        "itemCode":"8.10"
                    },
                    {
                        "itemCode":"8.11"
                    },
                    {
                        "itemCode":"8.12"
                    },
                    {
                        "itemCode":"8.13"
                    },
                    {
                        "itemCode":"8.14"
                    },
                    {
                        "itemCode":"8.15"
                    },
                    {
                        "itemCode":"8.16"
                    },
                    {
                        "itemCode":"8.17"
                    }
                ]
            },
            {
                "section":"09",
                "items":[
                    {
                        "itemCode":"9.1"
                    },
                    {
                        "itemCode":"9.2"
                    },
                    {
                        "itemCode":"9.3"
                    },
                ]
            }
        ],
        "sampleInfos":[
            {
                "product":"01",
                "testType":"finishedGood",
                "testName":"杏仁玄米餅",
                "finishedGoodTestName":"杏仁玄米餅",
                "testItems":[{testItem:"01"},{testItem:"02", details:["0201","0202"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"台東廠",
                "originPlace":"台灣",
                "testResult":"qualified",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-12-31T08:20:10.000Z",
                "packingSpec":"200g/盒",
                "lotNo":"2019-08-03-2",
                "model":"LC-2K004"
            },
            {
                "product":"03",
                "testType":"rawMaterial",
                "testName":"桂圓四物飲-原料1",
                "rawMaterialTestName":"01",
                "testItems":[{testItem:"01"},{testItem:"03", details:["0301","0303"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"原料1製造商",
                "originPlace":"美國",
                "testResult":"unqualified",
                "unqualifiedReason":"賽滅寧0.5PPM(0.1PPM)",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-09-13T08:20:10.000Z",
                "lotNo":"2018007",
                "model":"HFT-40"
            }
        ],
        "reviewerConclusions":[
            {"reviewer":"王小明","reviewConclusion":"approve"},
            {"reviewer":"王大同","reviewConclusion":"improvement"},
        ],
        "improvementWeeks":3,
        "followUpRequests":[
            {
                "carNo":"INS01-01",
                "ncrType":"primary",
                "checkItems":["02-1","04-2"],
                "observation":"廠外環境污染源現況與申請資料描述不一致",
                "nextInspectionFocus":true,
                "reviewResult":"correct",
                "reviewersOpinions":[
                    {
                        "reviewer":"王小明",
                        "nextInspectionFocus":true,
                        "reviewResult":"correct",
                        "comment":"Gurman 並且稱該頭戴裝置「最快 2022」年可以到來，而且未來蘋果也會推出「單純 AR」的機種，但那要再多等幾年才會來臨了"
                    },
                    {
                        "reviewer":"王大同",
                        "nextInspectionFocus":true,
                        "reviewResult":"correct",
                        "comment":"眾人在期待的，更多還是蘋果能不能利用其格外強大的產品開發與行銷能力，將 MR 帶進主流"
                    }
                ],
                "ncrs":{
                    "type":"secondary",
                    "no":"INS01-01",
                    "itemCode": "1.1",
                    "observationDesc":"碳酸鈣99.95 Suprapur®. REACH(歐盟關於化學品註 ... 建議的貯存溫度, 看產品標籤",
                    "nextInspectionFocus":true,
                    "referencedRegulations":["里仁細則5.10","里仁細則6.2.1"],
                    "ncImprovement":"online",
                    "correctionActionPlan":"由工程主辦機關(監造單位)建立品質保證系統,當監測發現CCP點失控或偏離管制界限時，需要採取矯正措施的行動，確保任何不安全的食品都能被攔除",
                    "evaluateCorrectiveAction":"agree",
                    "evaluateContent":"確認已改善",
                    "reviewResults":[],
                },
            },
            {
                "carNo":"INS01-02",
                "ncrType":"secondary",
                "checkItems":["03-1"],
                "observation":"客戶提供之評鑑場所平面圖與實際看到者不一致",
                "nextInspectionFocus":true,
                "reviewResult":"track",
                "reviewersOpinions":[
                    {
                        "reviewer":"王小明",
                        "nextInspectionFocus":true,
                        "reviewResult":"track",
                        "comment":"Gurman 並且稱該頭戴裝置「最快 2022」年可以到來，而且未來蘋果也會推出「單純 AR」的機種，但那要再多等幾年才會來臨了"
                    },
                    {
                        "reviewer":"王大同",
                        "nextInspectionFocus":true,
                        "reviewResult":"track",
                        "comment":"眾人在期待的，更多還是蘋果能不能利用其格外強大的產品開發與行銷能力，將 MR 帶進主流"
                    }
                ],
                "ncrs": {
                    "type": "secondary",
                    "no": "INS01-01",
                    "itemCode": "1.1",
                    "observationDesc": "碳酸鈣99.95 Suprapur®. REACH(歐盟關於化學品註 ... 建議的貯存溫度, 看產品標籤",
                    "nextInspectionFocus": true,
                    "referencedRegulations": ["里仁細則5.10", "里仁細則6.2.1"],
                    "ncImprovement": "online",
                    "correctionActionPlan": "由工程主辦機關(監造單位)建立品質保證系統,當監測發現CCP點失控或偏離管制界限時，需要採取矯正措施的行動，確保任何不安全的食品都能被攔除",
                    "evaluateCorrectiveAction": "agree",
                    "evaluateContent": "確認已改善",
                    "reviewResults": [],
                },
            },
            {
                "carNo":"INS01-03",
                "ncrType":"secondary",
                "checkItems":["06-1","06-2"],
                "observation":"原料相關證明文件或檢驗報告可與使用原料來源沒有勾稽",
                "reviewersOpinions":[
                    {
                        "reviewer":"王小明",
                        "nextInspectionFocus":true,
                        "reviewResult":"track",
                        "comment":"Gurman 並且稱該頭戴裝置「最快 2022」年可以到來，而且未來蘋果也會推出「單純 AR」的機種，但那要再多等幾年才會來臨了"
                    },
                    {
                        "reviewer":"王大同",
                        "reviewResult":"correct",
                        "comment":"眾人在期待的，更多還是蘋果能不能利用其格外強大的產品開發與行銷能力，將 MR 帶進主流"
                    }
                ],
                "ncrs":{
                    "type":"secondary",
                    "no":"INS01-02",
                    "itemCode": "1.2",
                    "observationDesc":"實衛生管理工作，確保產品在良好環境下產製，使食品品質及其安定性等各項管制作. 業得以有效進行。",
                    "nextInspectionFocus":true,
                    "correctionActionPlan":"核項目及觀察注意事項，評鑑結果應能顯示全數合格及缺失改善完成",
                    "referencedRegulations":["里仁細則5.10","慈悅第三部分 評鑑作業流程3.3.1"],
                    "ncImprovement":"online",
                    "evaluateCorrectiveAction":"agree",
                    "evaluateContent":"確認已改善",
                    "reviewResults":[],
                },
            },
            {
                "checkItems":["06-3"],
                "ncrType":"secondary",
                "observation":"原材料進貨時沒有驗收紀錄",
                "nextInspectionFocus":true,
                "reviewResult":"track",
                "reviewersOpinions":[
                    {
                        "reviewer":"王小明",
                        "nextInspectionFocus":true,
                        "reviewResult":"track",
                        "comment":"Gurman 並且稱該頭戴裝置「最快 2022」年可以到來，而且未來蘋果也會推出「單純 AR」的機種，但那要再多等幾年才會來臨了"
                    },
                ],
                "ncrs":{
                    "type":"secondary",
                    "no":"INS01-03",
                    "itemCode": "1.3",
                    "observationDesc":"程序書提供範例僅供參考，其中的條件、頻率或數字應以業者實際操作流程而適當 ... 目的:為建立本廠醬油產品製程及品質管制作業程序。",
                    "nextInspectionFocus":true,
                    "referencedRegulations":["GHP附表一.一.(三)"],
                    "ncImprovement":"online",
                    "correctionActionPlan":"稽核完成後，由食品安全決策小組召集稽核人員及受稽核單位，舉行結束會議，請稽核人員對稽核缺失進行報告，受稽核單位對稽核報告確認無誤，雙方當場於稽核查檢紀錄表簽字，受稽核單位於一個月內回覆內部稽核異常處理紀錄表。",
                    "evaluateCorrectiveAction":"improve",
                    "evaluateContent":"規劃再確認輸入食品衛生安全之流程，必要時進行矯正措施或修訂食品安全監測計畫",
                    "reviewResults":[],
                },
            }
        ],
        "otherAttentions":[
            {"otherAttention":"武陵農場一年一度的櫻花季，將在明年2月12日登場，11月1日早上8點半，開放散客預約住宿，短短5分鐘將近2000間的房間，全被預訂一空", "reviewer":"王小明"},
            {"otherAttention":"多選用新鮮食品，配料及調味料需留意有效期限及保存條件，不使用來路不明的食材，也要避免剩餘菜餚反覆加熱食用", "reviewer":"王大同"}
        ],
        "addSampleInfos":[
            {
                "product":"01",
                "testType":"finishedGood",
                "testName":"杏仁玄米餅",
                "finishedGoodTestName":"杏仁玄米餅",
                "testItems":[{testItem:"01"},{testItem:"02", details:["0201","0202"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"台東廠",
                "originPlace":"台灣",
                "testResult":"qualified",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-12-31T08:20:10.000Z",
                "packingSpec":"200g/盒",
                "lotNo":"2019-08-03-2",
                "model":"LC-2K004"
            },
            {
                "product":"03",
                "testType":"rawMaterial",
                "testName":"桂圓四物飲-原料1",
                "rawMaterialTestName":"01",
                "testItems":[{testItem:"01"},{testItem:"03", details:["0301","0303"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"原料1製造商",
                "originPlace":"美國",
                "testResult":"unqualified",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-09-13T08:20:10.000Z",
                "lotNo":"2018007",
                "model":"HFT-40"
            }
        ],
    },
    {
        "uuid": "5",
        "no": "A21080205",
        "customerNo": "0005",
        "customerName": "育豪食品股份有限公司",
        "assessmentPlace":"台東廠",
        "appType": "followUp",
        "applyStandard": "tseyue",
        "meetingDate": "2021-12-02T08:20:10.000Z",
        "projectManager": "許阿美",
        "phase": "assessmentReview",
        "activity": "assessmentReview_S30",
        "inspectionContent":{
            "standard":"leezen",
            "inspectionItems":[
                {"productionLine":"line1", "products":["Natural Benefits 食安生技-椰子汁"]},
                {"productionLine":"line2", "products":["杏仁玄米餅","核桃酥"]}
            ],
            "inspectionScope":"評鑑產品之評鑑場所場區環境與衛生管理、製程與品質管制、原料查驗、相關檢驗報告與紀錄表單核對等，及前次所列查驗重點之執行狀況確認",
            "manufacturingProcess": "製程......\n......\n......\n......"
        },
        "inspectionResult":{
            "previousNcrs":[
                {
                    "appNo":"A20080111",
                    "type":"secondary",
                    "inspectionItem":"03-3",
                    "observationDesc":"碳酸鈣550g/包,未涵蓋使用範圍",
                    "status": "improved",
                    "comments": "說明......"
                },
                {
                    "appNo":"A20080111",
                    "type":"secondary",
                    "inspectionItem":"06-1",
                    "observationDesc":"評鑑產品之評鑑場所場區環境與衛生管理、製程與品質管制",
                    "status": "notImproved",
                    "comments": "說明......"
                }
            ],
            "productChangeInspection": "品變編號說明......",
            "otherSupplement": "漏開缺失說明......",
            "leezenRawMaterials":[
                {
                    "id":"1",
                    "type":"material",
                    "name":"豆蓉粉(新版)",
                    "storageCondition":"roomTemperature",
                    "composition":"水、非基因改造脫脂黃豆片、小麥、食鹽、轉化液糖(蔗糖、水)、調味劑(DL-蘋果酸)",
                    "domesticVendor":"穎昌食品有限公司(新和美)",
                    "importer":"",
                    "manufacturer":"穎昌食品有限公司(新和美)",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "addRatio":9,
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":1,
                    "validityAndSituation":"有效日期：2022/03/19(此批非里仁使用)",
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"2",
                    "type":"material",
                    "name":"美國加州杏仁果",
                    "storageCondition":"roomTemperature",
                    "composition":"樹薯澱粉、水(原料)",
                    "domesticVendor":"信成股份有限公司",
                    "importer":"信成股份有限公司",
                    "manufacturer":"TERRA NOVA TRADING INC.",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":2,
                    "validityAndSituation":"有效日期：2023/04/18",
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"3",
                    "name":"美國加州杏仁果",
                    "storageCondition":"refrigeration",
                    "composition":"植物油脂(菜籽油)、洋蔥、葡萄糖、抗氧化劑(維生素C、混合濃縮生育醇)",
                    "domesticVendor":"爾邦得有限公司",
                    "importer":"爾邦得有限公司",
                    "manufacturer":"TERRA NOVA TRADING INC.",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":3,
                    "validityAndSituation":"槽車運送日期2021/09/14(保存期限3個月)，平均約1個月左右進貨一次，\n" +
                        "當天使用有效日期2021.11.17(8/17進貨)",
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"4",
                    "name":"美國加州杏仁果",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"信和股份有限公司",
                    "importer":"信和股份有限公司",
                    "manufacturer":"RPAC,LLC",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":4,
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"5",
                    "name":"美國加州杏仁果",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"信和股份有限公司",
                    "importer":"信和股份有限公司",
                    "manufacturer":"VANN FAMLLY ORCHARDS",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":5,
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"6",
                    "name":"甜扁桃仁粒",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"成久旺股份有限公司",
                    "importer":"成久旺股份有限公司",
                    "manufacturer":"TWIN COMMODITIES,INC.",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":6,
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"7",
                    "name":"帶皮杏仁粒",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"昇祥股份有限公司",
                    "importer":"昇祥股份有限公司",
                    "manufacturer":"美國加州皮爾農場公司",
                    "originPlace":"美國加州",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":7,
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"8",
                    "name":"有機生糙米粉(台灣)",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"青田農產有限公司",
                    "importer":"",
                    "manufacturer":"青田農產有限公司",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":8,
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"9",
                    "name":"精製椰子油",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"禾發實業有限公司",
                    "importer":"禾發實業有限公司",
                    "manufacturer":"OLEO-FATS, INCORPORATED",
                    "originPlace":"菲律賓",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":9,
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"10",
                    "name":"杏仁細粉",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"迦得貿易實業有限公司",
                    "importer":"迦得貿易實業有限公司",
                    "manufacturer":"Treehouse California Almonds LLC",
                    "originPlace":"菲律賓",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":10,
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"11",
                    "name":"杏仁粉(細)",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"成久旺股份有限公司",
                    "importer":"成久旺股份有限公司",
                    "manufacturer":"Treehouse California Almonds LLC",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":11,
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"12",
                    "name":"混合濃縮生育醇",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"信意企業股份有限公司",
                    "importer":"信意企業股份有限公司",
                    "manufacturer":"CARGILL INCORPORATED",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"衛部添製字第002764號/TFAA1N002764004",
                    "processingAid":"N",
                    "accessory":"N",
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                }
            ],
            "tseyueRawMaterials":[
                {
                    "id":"1",
                    "type":"material",
                    "name":"玉米粉",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"乖乖",
                    "importer":"",
                    "manufacturer":"乖乖",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "addRatio":9,
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":1,
                    "validityAndSituation":"有效日期：2022/3/15",
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"2",
                    "type":"material",
                    "name":"精製特砂",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"台糖",
                    "manufacturer":"台糖",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":2,
                    "validityAndSituation":"有效日期：2023/04/18",
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"3",
                    "name":"二次精製軟棕油",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"福懋油脂",
                    "manufacturer":"福懋油脂",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":3,
                    "validityAndSituation":"有效日期：2023/07/09",
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                }
            ]
        },
        "addedNcrs":[
            {
                "itemCode": "1.3",
                "observation": "建立品質保證系統並制定監造計畫，並落實執行現場施工品質抽查驗",
                "nextInspectionFocus": true,
                "reviewResult": "correct",
                "comment": "未落實執行現場施工品質抽查驗",
            }
        ],
        "previousNcrs":[
            {
                "appNo":"A20080111",
                "type":"secondary",
                "inspectionItem":"3.3",
                "ncrDesc":"碳酸鈣550g/包,未涵蓋使用範圍",
                "inspectorConfirmImprovement": "improved",
                "inspectorDesc": "稽核員說明......",
                "reviewerImplementationStatuses": [
                    {"reviewer": "委員1", "implementationStatus": "improved", "reviewDesc": "審查說明 審查說明 審查說明 審查說明 "},
                    {"reviewer": "委員2", "implementationStatus": "notImproved", "reviewDesc": "審查說明 審查說明 審查說明 審查說明 "},
                    {"reviewer": "委員3", "implementationStatus": "noNeedTrack", "reviewDesc": "審查說明 審查說明 審查說明 審查說明 "},
                ],
            },
            {
                "appNo":"A20080111",
                "type":"secondary",
                "inspectionItem":"6.1",
                "ncrDesc":"評鑑產品之評鑑場所場區環境與衛生管理、製程與品質管制",
                "inspectorConfirmImprovement": "notImproved",
                "inspectorDesc": "稽核員說明......",
                "reviewerImplementationStatuses": [
                    {"reviewer": "委員1", "implementationStatus": "improved", "reviewDesc": "審查說明 審查說明 審查說明 審查說明 "},
                    {"reviewer": "委員2", "implementationStatus": "notImproved", "reviewDesc": "審查說明 審查說明 審查說明 審查說明 "},
                    {"reviewer": "委員3", "implementationStatus": "noNeedTrack", "reviewDesc": "審查說明 審查說明 審查說明 審查說明 "},
                ],
            }
        ],
        "inspectionItems":[
            {
                "section":"01",
                "items":[
                    {
                        "itemCode":"1.1",
                        "result":"Y",
                        "observation":"全面品質管理的運作主要是利用計劃、實施、查核及改善的管理循環模式，加以落實。",
                        "createNcr":true,
                        "carNo":"INS01-01"
                    },
                    {
                        "itemCode":"1.2",
                        "result":"N",
                        "observation":"建立品質保證系統並制定監造計畫，並落實執行現場施工品質抽查驗",
                        "createNcr":true,
                        "carNo":"INS01-02"
                    },
                    {
                        "itemCode":"1.3",
                        "result":"Y",
                    },
                    {
                        "itemCode":"1.4",
                        "result":"notApplicable"
                    },
                    {
                        "itemCode":"1.5",
                    }
                ]
            },
            {
                "section":"02",
                "items":[
                    {
                        "itemCode":"2.1",
                        "result":"Y"
                    },
                    {
                        "itemCode":"2.2",
                        "result":"Y"
                    },
                    {
                        "itemCode":"2.3",
                        "result":"N"
                    },
                    {
                        "itemCode":"2.4",
                        "result":"Y"
                    },
                    {
                        "itemCode":"2.5",
                    }
                ]
            },
            {
                "section":"03",
                "items":[
                    {
                        "itemCode":"3.1"
                    },
                    {
                        "itemCode":"3.2"
                    },
                    {
                        "itemCode":"3.3"
                    },
                    {
                        "itemCode":"3.4"
                    },
                    {
                        "itemCode":"3.5"
                    },
                    {
                        "itemCode":"3.6",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.7",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.8",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.9",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.10",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.11",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.12",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.13",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.14"
                    }
                ]
            },
            {
                "section":"04",
                "items":[
                    {
                        "itemCode":"4.1"
                    },
                    {
                        "itemCode":"4.2"
                    },
                    {
                        "itemCode":"4.3"
                    },
                    {
                        "itemCode":"4.4"
                    },
                    {
                        "itemCode":"4.5"
                    },
                    {
                        "itemCode":"4.6"
                    },
                    {
                        "itemCode":"4.7"
                    },
                    {
                        "itemCode":"4.8"
                    },
                    {
                        "itemCode":"4.9"
                    },
                    {
                        "itemCode":"4.10"
                    },
                    {
                        "itemCode":"4.11"
                    },
                    {
                        "itemCode":"4.12"
                    },
                    {
                        "itemCode":"4.13"
                    },
                    {
                        "itemCode":"4.14"
                    },
                    {
                        "itemCode":"4.15"
                    },
                    {
                        "itemCode":"4.16"
                    },
                    {
                        "itemCode":"4.17"
                    },
                ]
            },
            {
                "section":"05",
                "items":[
                    {
                        "itemCode":"5.1"
                    },
                    {
                        "itemCode":"5.2"
                    },
                    {
                        "itemCode":"5.3"
                    },
                    {
                        "itemCode":"5.4"
                    },
                    {
                        "itemCode":"5.5"
                    },
                    {
                        "itemCode":"5.6"
                    },
                    {
                        "itemCode":"5.7"
                    },
                    {
                        "itemCode":"5.8"
                    },
                    {
                        "itemCode":"5.9"
                    },
                    {
                        "itemCode":"5.10"
                    },
                ]
            },
            {
                "section":"06",
                "items":[
                    {
                        "itemCode":"6.1"
                    },
                    {
                        "itemCode":"6.2"
                    },
                    {
                        "itemCode":"6.3"
                    },
                    {
                        "itemCode":"6.4"
                    },
                    {
                        "itemCode":"6.5"
                    },
                    {
                        "itemCode":"6.6"
                    },
                    {
                        "itemCode":"6.7"
                    },
                    {
                        "itemCode":"6.8"
                    },
                    {
                        "itemCode":"6.9"
                    },
                    {
                        "itemCode":"6.10"
                    },
                    {
                        "itemCode":"6.11"
                    },
                    {
                        "itemCode":"6.12"
                    },
                    {
                        "itemCode":"6.13"
                    },
                    {
                        "itemCode":"6.14"
                    },
                    {
                        "itemCode":"6.15"
                    },
                    {
                        "itemCode":"6.16"
                    },
                    {
                        "itemCode":"6.17"
                    },
                    {
                        "itemCode":"6.18"
                    },
                    {
                        "itemCode":"6.19"
                    },
                    {
                        "itemCode":"6.20"
                    },
                ]
            },
            {
                "section":"07",
                "items":[
                    {
                        "itemCode":"7.1"
                    },
                    {
                        "itemCode":"7.2"
                    },
                    {
                        "itemCode":"7.3"
                    },
                    {
                        "itemCode":"7.4"
                    },
                    {
                        "itemCode":"7.5"
                    },
                    {
                        "itemCode":"7.6"
                    },
                    {
                        "itemCode":"7.7"
                    },
                    {
                        "itemCode":"7.8"
                    },
                    {
                        "itemCode":"7.9"
                    }
                ]
            },
            {
                "section":"08",
                "items":[
                    {
                        "itemCode":"8.1"
                    },
                    {
                        "itemCode":"8.2"
                    },
                    {
                        "itemCode":"8.3"
                    },
                    {
                        "itemCode":"8.4"
                    },
                    {
                        "itemCode":"8.5"
                    },
                    {
                        "itemCode":"8.6"
                    },
                    {
                        "itemCode":"8.7"
                    },
                    {
                        "itemCode":"8.8"
                    },
                    {
                        "itemCode":"8.9"
                    },
                    {
                        "itemCode":"8.10"
                    },
                    {
                        "itemCode":"8.11"
                    },
                    {
                        "itemCode":"8.12"
                    },
                    {
                        "itemCode":"8.13"
                    },
                    {
                        "itemCode":"8.14"
                    },
                    {
                        "itemCode":"8.15"
                    },
                    {
                        "itemCode":"8.16"
                    },
                    {
                        "itemCode":"8.17"
                    }
                ]
            },
            {
                "section":"09",
                "items":[
                    {
                        "itemCode":"9.1"
                    },
                    {
                        "itemCode":"9.2"
                    },
                    {
                        "itemCode":"9.3"
                    },
                ]
            }
        ],
        "sampleInfos":[
            {
                "product":"01",
                "testType":"finishedGood",
                "testName":"杏仁玄米餅",
                "finishedGoodTestName":"杏仁玄米餅",
                "testItems":[{testItem:"01"},{testItem:"02", details:["0201","0202"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"台東廠",
                "originPlace":"台灣",
                "testResult":"qualified",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-12-31T08:20:10.000Z",
                "packingSpec":"200g/盒",
                "lotNo":"2019-08-03-2",
                "model":"LC-2K004"
            },
            {
                "product":"03",
                "testType":"rawMaterial",
                "testName":"桂圓四物飲-原料1",
                "rawMaterialTestName":"01",
                "testItems":[{testItem:"01"},{testItem:"03", details:["0301","0303"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"原料1製造商",
                "originPlace":"美國",
                "testResult":"unqualified",
                "unqualifiedReason":"賽滅寧0.5PPM(0.1PPM)",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-09-13T08:20:10.000Z",
                "lotNo":"2018007",
                "model":"HFT-40"
            }
        ],
        "reviewerConclusions":[
            {"reviewer":"王小明","reviewConclusion":"approve"},
            {"reviewer":"王大同","reviewConclusion":"improvement"},
        ],
        "improvementWeeks":3,
        "followUpRequests":[
            {
                "carNo":"INS01-01",
                "ncrType":"primary",
                "checkItems":["02-1","04-2"],
                "observation":"廠外環境污染源現況與申請資料描述不一致",
                "nextInspectionFocus":true,
                "reviewResult":"correct",
                "reviewersOpinions":[
                    {
                        "reviewer":"王小明",
                        "nextInspectionFocus":true,
                        "reviewResult":"correct",
                        "comment":"Gurman 並且稱該頭戴裝置「最快 2022」年可以到來，而且未來蘋果也會推出「單純 AR」的機種，但那要再多等幾年才會來臨了"
                    },
                    {
                        "reviewer":"王大同",
                        "nextInspectionFocus":true,
                        "reviewResult":"correct",
                        "comment":"眾人在期待的，更多還是蘋果能不能利用其格外強大的產品開發與行銷能力，將 MR 帶進主流"
                    }
                ],
                "ncrs":{
                    "type":"secondary",
                    "no":"INS01-01",
                    "itemCode": "1.1",
                    "observationDesc":"碳酸鈣99.95 Suprapur®. REACH(歐盟關於化學品註 ... 建議的貯存溫度, 看產品標籤",
                    "nextInspectionFocus":true,
                    "referencedRegulations":["里仁細則5.10","里仁細則6.2.1"],
                    "ncImprovement":"online",
                    "correctionActionPlan":"由工程主辦機關(監造單位)建立品質保證系統,當監測發現CCP點失控或偏離管制界限時，需要採取矯正措施的行動，確保任何不安全的食品都能被攔除",
                    "evaluateCorrectiveAction":"agree",
                    "evaluateContent":"確認已改善",
                    "reviewResults":[],
                },
            },
            {
                "carNo":"INS01-02",
                "ncrType":"secondary",
                "checkItems":["03-1"],
                "observation":"客戶提供之評鑑場所平面圖與實際看到者不一致",
                "nextInspectionFocus":true,
                "reviewResult":"track",
                "reviewersOpinions":[
                    {
                        "reviewer":"王小明",
                        "nextInspectionFocus":true,
                        "reviewResult":"track",
                        "comment":"Gurman 並且稱該頭戴裝置「最快 2022」年可以到來，而且未來蘋果也會推出「單純 AR」的機種，但那要再多等幾年才會來臨了"
                    },
                    {
                        "reviewer":"王大同",
                        "nextInspectionFocus":true,
                        "reviewResult":"track",
                        "comment":"眾人在期待的，更多還是蘋果能不能利用其格外強大的產品開發與行銷能力，將 MR 帶進主流"
                    }
                ],
                "ncrs": {
                    "type": "secondary",
                    "no": "INS01-01",
                    "itemCode": "1.1",
                    "observationDesc": "碳酸鈣99.95 Suprapur®. REACH(歐盟關於化學品註 ... 建議的貯存溫度, 看產品標籤",
                    "nextInspectionFocus": true,
                    "referencedRegulations": ["里仁細則5.10", "里仁細則6.2.1"],
                    "ncImprovement": "online",
                    "correctionActionPlan": "由工程主辦機關(監造單位)建立品質保證系統,當監測發現CCP點失控或偏離管制界限時，需要採取矯正措施的行動，確保任何不安全的食品都能被攔除",
                    "evaluateCorrectiveAction": "agree",
                    "evaluateContent": "確認已改善",
                    "reviewResults": [],
                },
            },
            {
                "carNo":"INS01-03",
                "ncrType":"secondary",
                "checkItems":["06-1","06-2"],
                "observation":"原料相關證明文件或檢驗報告可與使用原料來源沒有勾稽",
                "reviewersOpinions":[
                    {
                        "reviewer":"王小明",
                        "nextInspectionFocus":true,
                        "reviewResult":"track",
                        "comment":"Gurman 並且稱該頭戴裝置「最快 2022」年可以到來，而且未來蘋果也會推出「單純 AR」的機種，但那要再多等幾年才會來臨了"
                    },
                    {
                        "reviewer":"王大同",
                        "reviewResult":"correct",
                        "comment":"眾人在期待的，更多還是蘋果能不能利用其格外強大的產品開發與行銷能力，將 MR 帶進主流"
                    }
                ],
                "ncrs":{
                    "type":"secondary",
                    "no":"INS01-02",
                    "itemCode": "1.2",
                    "observationDesc":"實衛生管理工作，確保產品在良好環境下產製，使食品品質及其安定性等各項管制作. 業得以有效進行。",
                    "nextInspectionFocus":true,
                    "correctionActionPlan":"核項目及觀察注意事項，評鑑結果應能顯示全數合格及缺失改善完成",
                    "referencedRegulations":["里仁細則5.10","慈悅第三部分 評鑑作業流程3.3.1"],
                    "ncImprovement":"online",
                    "evaluateCorrectiveAction":"agree",
                    "evaluateContent":"確認已改善",
                    "reviewResults":[],
                },
            },
            {
                "checkItems":["06-3"],
                "ncrType":"secondary",
                "observation":"原材料進貨時沒有驗收紀錄",
                "nextInspectionFocus":true,
                "reviewResult":"track",
                "reviewersOpinions":[
                    {
                        "reviewer":"王小明",
                        "nextInspectionFocus":true,
                        "reviewResult":"track",
                        "comment":"Gurman 並且稱該頭戴裝置「最快 2022」年可以到來，而且未來蘋果也會推出「單純 AR」的機種，但那要再多等幾年才會來臨了"
                    },
                ],
                "ncrs":{
                    "type":"secondary",
                    "no":"INS01-03",
                    "itemCode": "1.3",
                    "observationDesc":"程序書提供範例僅供參考，其中的條件、頻率或數字應以業者實際操作流程而適當 ... 目的:為建立本廠醬油產品製程及品質管制作業程序。",
                    "nextInspectionFocus":true,
                    "referencedRegulations":["GHP附表一.一.(三)"],
                    "ncImprovement":"online",
                    "correctionActionPlan":"稽核完成後，由食品安全決策小組召集稽核人員及受稽核單位，舉行結束會議，請稽核人員對稽核缺失進行報告，受稽核單位對稽核報告確認無誤，雙方當場於稽核查檢紀錄表簽字，受稽核單位於一個月內回覆內部稽核異常處理紀錄表。",
                    "evaluateCorrectiveAction":"improve",
                    "evaluateContent":"規劃再確認輸入食品衛生安全之流程，必要時進行矯正措施或修訂食品安全監測計畫",
                    "reviewResults":[],
                },
            }
        ],
        "otherAttentions":[
            {"otherAttention":"武陵農場一年一度的櫻花季，將在明年2月12日登場，11月1日早上8點半，開放散客預約住宿，短短5分鐘將近2000間的房間，全被預訂一空", "reviewer":"王小明"},
            {"otherAttention":"多選用新鮮食品，配料及調味料需留意有效期限及保存條件，不使用來路不明的食材，也要避免剩餘菜餚反覆加熱食用", "reviewer":"王大同"}
        ],
        "addSampleInfos":[
            {
                "product":"01",
                "testType":"finishedGood",
                "testName":"杏仁玄米餅",
                "finishedGoodTestName":"杏仁玄米餅",
                "testItems":[{testItem:"01"},{testItem:"02", details:["0201","0202"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"台東廠",
                "originPlace":"台灣",
                "testResult":"qualified",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-12-31T08:20:10.000Z",
                "packingSpec":"200g/盒",
                "lotNo":"2019-08-03-2",
                "model":"LC-2K004"
            },
            {
                "product":"03",
                "testType":"rawMaterial",
                "testName":"桂圓四物飲-原料1",
                "rawMaterialTestName":"01",
                "testItems":[{testItem:"01"},{testItem:"03", details:["0301","0303"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"原料1製造商",
                "originPlace":"美國",
                "testResult":"unqualified",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-09-13T08:20:10.000Z",
                "lotNo":"2018007",
                "model":"HFT-40"
            }
        ],
    },
    {
        "uuid": "6",
        "no": "A21080206",
        "customerNo": "0006",
        "customerName": "陳記食品股份有限公司",
        "assessmentPlace":"台東廠",
        "appType": "renewal",
        "applyStandard": "leezen",
        "meetingDate": "2021-12-02T08:20:10.000Z",
        "projectManager": "許阿美",
        "phase": "assessmentReview",
        "activity": "assessmentReview_S30",
        "inspectionContent":{
            "standard":"leezen",
            "inspectionItems":[
                {"productionLine":"line1", "products":["Natural Benefits 食安生技-椰子汁"]},
                {"productionLine":"line2", "products":["杏仁玄米餅","核桃酥"]}
            ],
            "inspectionScope":"評鑑產品之評鑑場所場區環境與衛生管理、製程與品質管制、原料查驗、相關檢驗報告與紀錄表單核對等，及前次所列查驗重點之執行狀況確認",
            "manufacturingProcess": "製程......\n......\n......\n......"
        },
        "inspectionResult":{
            "previousNcrs":[
                {
                    "appNo":"A20080111",
                    "type":"secondary",
                    "inspectionItem":"03-3",
                    "observationDesc":"碳酸鈣550g/包,未涵蓋使用範圍",
                    "status": "improved",
                    "comments": "說明......"
                },
                {
                    "appNo":"A20080111",
                    "type":"secondary",
                    "inspectionItem":"06-1",
                    "observationDesc":"評鑑產品之評鑑場所場區環境與衛生管理、製程與品質管制",
                    "status": "notImproved",
                    "comments": "說明......"
                }
            ],
            "productChangeInspection": "品變編號說明......",
            "otherSupplement": "漏開缺失說明......",
            "leezenRawMaterials":[
                {
                    "id":"1",
                    "type":"material",
                    "name":"豆蓉粉(新版)",
                    "storageCondition":"roomTemperature",
                    "composition":"水、非基因改造脫脂黃豆片、小麥、食鹽、轉化液糖(蔗糖、水)、調味劑(DL-蘋果酸)",
                    "domesticVendor":"穎昌食品有限公司(新和美)",
                    "importer":"",
                    "manufacturer":"穎昌食品有限公司(新和美)",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "addRatio":9,
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":1,
                    "validityAndSituation":"有效日期：2022/03/19(此批非里仁使用)",
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"2",
                    "type":"material",
                    "name":"美國加州杏仁果",
                    "storageCondition":"roomTemperature",
                    "composition":"樹薯澱粉、水(原料)",
                    "domesticVendor":"信成股份有限公司",
                    "importer":"信成股份有限公司",
                    "manufacturer":"TERRA NOVA TRADING INC.",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":2,
                    "validityAndSituation":"有效日期：2023/04/18",
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"3",
                    "name":"美國加州杏仁果",
                    "storageCondition":"refrigeration",
                    "composition":"植物油脂(菜籽油)、洋蔥、葡萄糖、抗氧化劑(維生素C、混合濃縮生育醇)",
                    "domesticVendor":"爾邦得有限公司",
                    "importer":"爾邦得有限公司",
                    "manufacturer":"TERRA NOVA TRADING INC.",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":3,
                    "validityAndSituation":"槽車運送日期2021/09/14(保存期限3個月)，平均約1個月左右進貨一次，\n" +
                        "當天使用有效日期2021.11.17(8/17進貨)",
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"4",
                    "name":"美國加州杏仁果",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"信和股份有限公司",
                    "importer":"信和股份有限公司",
                    "manufacturer":"RPAC,LLC",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":4,
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"5",
                    "name":"美國加州杏仁果",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"信和股份有限公司",
                    "importer":"信和股份有限公司",
                    "manufacturer":"VANN FAMLLY ORCHARDS",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":5,
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"6",
                    "name":"甜扁桃仁粒",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"成久旺股份有限公司",
                    "importer":"成久旺股份有限公司",
                    "manufacturer":"TWIN COMMODITIES,INC.",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":6,
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"7",
                    "name":"帶皮杏仁粒",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"昇祥股份有限公司",
                    "importer":"昇祥股份有限公司",
                    "manufacturer":"美國加州皮爾農場公司",
                    "originPlace":"美國加州",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":7,
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"8",
                    "name":"有機生糙米粉(台灣)",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"青田農產有限公司",
                    "importer":"",
                    "manufacturer":"青田農產有限公司",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":8,
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"9",
                    "name":"精製椰子油",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"禾發實業有限公司",
                    "importer":"禾發實業有限公司",
                    "manufacturer":"OLEO-FATS, INCORPORATED",
                    "originPlace":"菲律賓",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":9,
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"10",
                    "name":"杏仁細粉",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"迦得貿易實業有限公司",
                    "importer":"迦得貿易實業有限公司",
                    "manufacturer":"Treehouse California Almonds LLC",
                    "originPlace":"菲律賓",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":10,
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"11",
                    "name":"杏仁粉(細)",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"成久旺股份有限公司",
                    "importer":"成久旺股份有限公司",
                    "manufacturer":"Treehouse California Almonds LLC",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":11,
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"12",
                    "name":"混合濃縮生育醇",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"信意企業股份有限公司",
                    "importer":"信意企業股份有限公司",
                    "manufacturer":"CARGILL INCORPORATED",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"衛部添製字第002764號/TFAA1N002764004",
                    "processingAid":"N",
                    "accessory":"N",
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                }
            ],
            "tseyueRawMaterials":[
                {
                    "id":"1",
                    "type":"material",
                    "name":"玉米粉",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"乖乖",
                    "importer":"",
                    "manufacturer":"乖乖",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "addRatio":9,
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":1,
                    "validityAndSituation":"有效日期：2022/3/15",
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"2",
                    "type":"material",
                    "name":"精製特砂",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"台糖",
                    "manufacturer":"台糖",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":2,
                    "validityAndSituation":"有效日期：2023/04/18",
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"3",
                    "name":"二次精製軟棕油",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"福懋油脂",
                    "manufacturer":"福懋油脂",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":3,
                    "validityAndSituation":"有效日期：2023/07/09",
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                }
            ]
        },
        "addedNcrs":[
            {
                "itemCode": "1.3",
                "observation": "建立品質保證系統並制定監造計畫，並落實執行現場施工品質抽查驗",
                "nextInspectionFocus": true,
                "reviewResult": "correct",
                "comment": "未落實執行現場施工品質抽查驗",
            }
        ],
        "previousNcrs":[
            {
                "appNo":"A20080111",
                "type":"secondary",
                "inspectionItem":"3.3",
                "ncrDesc":"碳酸鈣550g/包,未涵蓋使用範圍",
                "inspectorConfirmImprovement": "improved",
                "inspectorDesc": "稽核員說明......",
                "reviewerImplementationStatuses": [
                    {"reviewer": "委員1", "implementationStatus": "improved", "reviewDesc": "審查說明 審查說明 審查說明 審查說明 "},
                    {"reviewer": "委員2", "implementationStatus": "notImproved", "reviewDesc": "審查說明 審查說明 審查說明 審查說明 "},
                    {"reviewer": "委員3", "implementationStatus": "noNeedTrack", "reviewDesc": "審查說明 審查說明 審查說明 審查說明 "},
                ],
            },
            {
                "appNo":"A20080111",
                "type":"secondary",
                "inspectionItem":"6.1",
                "ncrDesc":"評鑑產品之評鑑場所場區環境與衛生管理、製程與品質管制",
                "inspectorConfirmImprovement": "notImproved",
                "inspectorDesc": "稽核員說明......",
                "reviewerImplementationStatuses": [
                    {"reviewer": "委員1", "implementationStatus": "improved", "reviewDesc": "審查說明 審查說明 審查說明 審查說明 "},
                    {"reviewer": "委員2", "implementationStatus": "notImproved", "reviewDesc": "審查說明 審查說明 審查說明 審查說明 "},
                    {"reviewer": "委員3", "implementationStatus": "noNeedTrack", "reviewDesc": "審查說明 審查說明 審查說明 審查說明 "},
                ],
            }
        ],
        "inspectionItems":[
            {
                "section":"01",
                "items":[
                    {
                        "itemCode":"1.1",
                        "result":"Y",
                        "observation":"全面品質管理的運作主要是利用計劃、實施、查核及改善的管理循環模式，加以落實。",
                        "createNcr":true,
                        "carNo":"INS01-01"
                    },
                    {
                        "itemCode":"1.2",
                        "result":"N",
                        "observation":"建立品質保證系統並制定監造計畫，並落實執行現場施工品質抽查驗",
                        "createNcr":true,
                        "carNo":"INS01-02"
                    },
                    {
                        "itemCode":"1.3",
                        "result":"Y",
                    },
                    {
                        "itemCode":"1.4",
                        "result":"notApplicable"
                    },
                    {
                        "itemCode":"1.5",
                    }
                ]
            },
            {
                "section":"02",
                "items":[
                    {
                        "itemCode":"2.1",
                        "result":"Y"
                    },
                    {
                        "itemCode":"2.2",
                        "result":"Y"
                    },
                    {
                        "itemCode":"2.3",
                        "result":"N"
                    },
                    {
                        "itemCode":"2.4",
                        "result":"Y"
                    },
                    {
                        "itemCode":"2.5",
                    }
                ]
            },
            {
                "section":"03",
                "items":[
                    {
                        "itemCode":"3.1"
                    },
                    {
                        "itemCode":"3.2"
                    },
                    {
                        "itemCode":"3.3"
                    },
                    {
                        "itemCode":"3.4"
                    },
                    {
                        "itemCode":"3.5"
                    },
                    {
                        "itemCode":"3.6",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.7",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.8",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.9",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.10",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.11",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.12",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.13",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.14"
                    }
                ]
            },
            {
                "section":"04",
                "items":[
                    {
                        "itemCode":"4.1"
                    },
                    {
                        "itemCode":"4.2"
                    },
                    {
                        "itemCode":"4.3"
                    },
                    {
                        "itemCode":"4.4"
                    },
                    {
                        "itemCode":"4.5"
                    },
                    {
                        "itemCode":"4.6"
                    },
                    {
                        "itemCode":"4.7"
                    },
                    {
                        "itemCode":"4.8"
                    },
                    {
                        "itemCode":"4.9"
                    },
                    {
                        "itemCode":"4.10"
                    },
                    {
                        "itemCode":"4.11"
                    },
                    {
                        "itemCode":"4.12"
                    },
                    {
                        "itemCode":"4.13"
                    },
                    {
                        "itemCode":"4.14"
                    },
                    {
                        "itemCode":"4.15"
                    },
                    {
                        "itemCode":"4.16"
                    },
                    {
                        "itemCode":"4.17"
                    },
                ]
            },
            {
                "section":"05",
                "items":[
                    {
                        "itemCode":"5.1"
                    },
                    {
                        "itemCode":"5.2"
                    },
                    {
                        "itemCode":"5.3"
                    },
                    {
                        "itemCode":"5.4"
                    },
                    {
                        "itemCode":"5.5"
                    },
                    {
                        "itemCode":"5.6"
                    },
                    {
                        "itemCode":"5.7"
                    },
                    {
                        "itemCode":"5.8"
                    },
                    {
                        "itemCode":"5.9"
                    },
                    {
                        "itemCode":"5.10"
                    },
                ]
            },
            {
                "section":"06",
                "items":[
                    {
                        "itemCode":"6.1"
                    },
                    {
                        "itemCode":"6.2"
                    },
                    {
                        "itemCode":"6.3"
                    },
                    {
                        "itemCode":"6.4"
                    },
                    {
                        "itemCode":"6.5"
                    },
                    {
                        "itemCode":"6.6"
                    },
                    {
                        "itemCode":"6.7"
                    },
                    {
                        "itemCode":"6.8"
                    },
                    {
                        "itemCode":"6.9"
                    },
                    {
                        "itemCode":"6.10"
                    },
                    {
                        "itemCode":"6.11"
                    },
                    {
                        "itemCode":"6.12"
                    },
                    {
                        "itemCode":"6.13"
                    },
                    {
                        "itemCode":"6.14"
                    },
                    {
                        "itemCode":"6.15"
                    },
                    {
                        "itemCode":"6.16"
                    },
                    {
                        "itemCode":"6.17"
                    },
                    {
                        "itemCode":"6.18"
                    },
                    {
                        "itemCode":"6.19"
                    },
                    {
                        "itemCode":"6.20"
                    },
                ]
            },
            {
                "section":"07",
                "items":[
                    {
                        "itemCode":"7.1"
                    },
                    {
                        "itemCode":"7.2"
                    },
                    {
                        "itemCode":"7.3"
                    },
                    {
                        "itemCode":"7.4"
                    },
                    {
                        "itemCode":"7.5"
                    },
                    {
                        "itemCode":"7.6"
                    },
                    {
                        "itemCode":"7.7"
                    },
                    {
                        "itemCode":"7.8"
                    },
                    {
                        "itemCode":"7.9"
                    }
                ]
            },
            {
                "section":"08",
                "items":[
                    {
                        "itemCode":"8.1"
                    },
                    {
                        "itemCode":"8.2"
                    },
                    {
                        "itemCode":"8.3"
                    },
                    {
                        "itemCode":"8.4"
                    },
                    {
                        "itemCode":"8.5"
                    },
                    {
                        "itemCode":"8.6"
                    },
                    {
                        "itemCode":"8.7"
                    },
                    {
                        "itemCode":"8.8"
                    },
                    {
                        "itemCode":"8.9"
                    },
                    {
                        "itemCode":"8.10"
                    },
                    {
                        "itemCode":"8.11"
                    },
                    {
                        "itemCode":"8.12"
                    },
                    {
                        "itemCode":"8.13"
                    },
                    {
                        "itemCode":"8.14"
                    },
                    {
                        "itemCode":"8.15"
                    },
                    {
                        "itemCode":"8.16"
                    },
                    {
                        "itemCode":"8.17"
                    }
                ]
            },
            {
                "section":"09",
                "items":[
                    {
                        "itemCode":"9.1"
                    },
                    {
                        "itemCode":"9.2"
                    },
                    {
                        "itemCode":"9.3"
                    },
                ]
            }
        ],
        "sampleInfos":[
            {
                "product":"01",
                "testType":"finishedGood",
                "testName":"杏仁玄米餅",
                "finishedGoodTestName":"杏仁玄米餅",
                "testItems":[{testItem:"01"},{testItem:"02", details:["0201","0202"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"台東廠",
                "originPlace":"台灣",
                "testResult":"qualified",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-12-31T08:20:10.000Z",
                "packingSpec":"200g/盒",
                "lotNo":"2019-08-03-2",
                "model":"LC-2K004"
            },
            {
                "product":"03",
                "testType":"rawMaterial",
                "testName":"桂圓四物飲-原料1",
                "rawMaterialTestName":"01",
                "testItems":[{testItem:"01"},{testItem:"03", details:["0301","0303"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"原料1製造商",
                "originPlace":"美國",
                "testResult":"unqualified",
                "unqualifiedReason":"賽滅寧0.5PPM(0.1PPM)",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-09-13T08:20:10.000Z",
                "lotNo":"2018007",
                "model":"HFT-40"
            }
        ],
        "reviewerConclusions":[
            {"reviewer":"王小明","reviewConclusion":"approve"},
            {"reviewer":"王大同","reviewConclusion":"improvement"},
        ],
        "improvementWeeks":3,
        "followUpRequests":[
            {
                "carNo":"INS01-01",
                "ncrType":"primary",
                "checkItems":["02-1","04-2"],
                "observation":"廠外環境污染源現況與申請資料描述不一致",
                "nextInspectionFocus":true,
                "reviewResult":"correct",
                "reviewersOpinions":[
                    {
                        "reviewer":"王小明",
                        "nextInspectionFocus":true,
                        "reviewResult":"correct",
                        "comment":"Gurman 並且稱該頭戴裝置「最快 2022」年可以到來，而且未來蘋果也會推出「單純 AR」的機種，但那要再多等幾年才會來臨了"
                    },
                    {
                        "reviewer":"王大同",
                        "nextInspectionFocus":true,
                        "reviewResult":"correct",
                        "comment":"眾人在期待的，更多還是蘋果能不能利用其格外強大的產品開發與行銷能力，將 MR 帶進主流"
                    }
                ],
                "ncrs":{
                    "type":"secondary",
                    "no":"INS01-01",
                    "itemCode": "1.1",
                    "observationDesc":"碳酸鈣99.95 Suprapur®. REACH(歐盟關於化學品註 ... 建議的貯存溫度, 看產品標籤",
                    "nextInspectionFocus":true,
                    "referencedRegulations":["里仁細則5.10","里仁細則6.2.1"],
                    "ncImprovement":"online",
                    "correctionActionPlan":"由工程主辦機關(監造單位)建立品質保證系統,當監測發現CCP點失控或偏離管制界限時，需要採取矯正措施的行動，確保任何不安全的食品都能被攔除",
                    "evaluateCorrectiveAction":"agree",
                    "evaluateContent":"確認已改善",
                    "reviewResults":[],
                },
            },
            {
                "carNo":"INS01-02",
                "ncrType":"secondary",
                "checkItems":["03-1"],
                "observation":"客戶提供之評鑑場所平面圖與實際看到者不一致",
                "nextInspectionFocus":true,
                "reviewResult":"track",
                "reviewersOpinions":[
                    {
                        "reviewer":"王小明",
                        "nextInspectionFocus":true,
                        "reviewResult":"track",
                        "comment":"Gurman 並且稱該頭戴裝置「最快 2022」年可以到來，而且未來蘋果也會推出「單純 AR」的機種，但那要再多等幾年才會來臨了"
                    },
                    {
                        "reviewer":"王大同",
                        "nextInspectionFocus":true,
                        "reviewResult":"track",
                        "comment":"眾人在期待的，更多還是蘋果能不能利用其格外強大的產品開發與行銷能力，將 MR 帶進主流"
                    }
                ],
                "ncrs": {
                    "type": "secondary",
                    "no": "INS01-01",
                    "itemCode": "1.1",
                    "observationDesc": "碳酸鈣99.95 Suprapur®. REACH(歐盟關於化學品註 ... 建議的貯存溫度, 看產品標籤",
                    "nextInspectionFocus": true,
                    "referencedRegulations": ["里仁細則5.10", "里仁細則6.2.1"],
                    "ncImprovement": "online",
                    "correctionActionPlan": "由工程主辦機關(監造單位)建立品質保證系統,當監測發現CCP點失控或偏離管制界限時，需要採取矯正措施的行動，確保任何不安全的食品都能被攔除",
                    "evaluateCorrectiveAction": "agree",
                    "evaluateContent": "確認已改善",
                    "reviewResults": [],
                },
            },
            {
                "carNo":"INS01-03",
                "ncrType":"secondary",
                "checkItems":["06-1","06-2"],
                "observation":"原料相關證明文件或檢驗報告可與使用原料來源沒有勾稽",
                "reviewersOpinions":[
                    {
                        "reviewer":"王小明",
                        "nextInspectionFocus":true,
                        "reviewResult":"track",
                        "comment":"Gurman 並且稱該頭戴裝置「最快 2022」年可以到來，而且未來蘋果也會推出「單純 AR」的機種，但那要再多等幾年才會來臨了"
                    },
                    {
                        "reviewer":"王大同",
                        "reviewResult":"correct",
                        "comment":"眾人在期待的，更多還是蘋果能不能利用其格外強大的產品開發與行銷能力，將 MR 帶進主流"
                    }
                ],
                "ncrs":{
                    "type":"secondary",
                    "no":"INS01-02",
                    "itemCode": "1.2",
                    "observationDesc":"實衛生管理工作，確保產品在良好環境下產製，使食品品質及其安定性等各項管制作. 業得以有效進行。",
                    "nextInspectionFocus":true,
                    "correctionActionPlan":"核項目及觀察注意事項，評鑑結果應能顯示全數合格及缺失改善完成",
                    "referencedRegulations":["里仁細則5.10","慈悅第三部分 評鑑作業流程3.3.1"],
                    "ncImprovement":"online",
                    "evaluateCorrectiveAction":"agree",
                    "evaluateContent":"確認已改善",
                    "reviewResults":[],
                },
            },
            {
                "checkItems":["06-3"],
                "ncrType":"secondary",
                "observation":"原材料進貨時沒有驗收紀錄",
                "nextInspectionFocus":true,
                "reviewResult":"track",
                "reviewersOpinions":[
                    {
                        "reviewer":"王小明",
                        "nextInspectionFocus":true,
                        "reviewResult":"track",
                        "comment":"Gurman 並且稱該頭戴裝置「最快 2022」年可以到來，而且未來蘋果也會推出「單純 AR」的機種，但那要再多等幾年才會來臨了"
                    },
                ],
                "ncrs":{
                    "type":"secondary",
                    "no":"INS01-03",
                    "itemCode": "1.3",
                    "observationDesc":"程序書提供範例僅供參考，其中的條件、頻率或數字應以業者實際操作流程而適當 ... 目的:為建立本廠醬油產品製程及品質管制作業程序。",
                    "nextInspectionFocus":true,
                    "referencedRegulations":["GHP附表一.一.(三)"],
                    "ncImprovement":"online",
                    "correctionActionPlan":"稽核完成後，由食品安全決策小組召集稽核人員及受稽核單位，舉行結束會議，請稽核人員對稽核缺失進行報告，受稽核單位對稽核報告確認無誤，雙方當場於稽核查檢紀錄表簽字，受稽核單位於一個月內回覆內部稽核異常處理紀錄表。",
                    "evaluateCorrectiveAction":"improve",
                    "evaluateContent":"規劃再確認輸入食品衛生安全之流程，必要時進行矯正措施或修訂食品安全監測計畫",
                    "reviewResults":[],
                },
            }
        ],
        "otherAttentions":[
            {"otherAttention":"武陵農場一年一度的櫻花季，將在明年2月12日登場，11月1日早上8點半，開放散客預約住宿，短短5分鐘將近2000間的房間，全被預訂一空", "reviewer":"王小明"},
            {"otherAttention":"多選用新鮮食品，配料及調味料需留意有效期限及保存條件，不使用來路不明的食材，也要避免剩餘菜餚反覆加熱食用", "reviewer":"王大同"}
        ],
        "addSampleInfos":[
            {
                "product":"01",
                "testType":"finishedGood",
                "testName":"杏仁玄米餅",
                "finishedGoodTestName":"杏仁玄米餅",
                "testItems":[{testItem:"01"},{testItem:"02", details:["0201","0202"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"台東廠",
                "originPlace":"台灣",
                "testResult":"qualified",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-12-31T08:20:10.000Z",
                "packingSpec":"200g/盒",
                "lotNo":"2019-08-03-2",
                "model":"LC-2K004"
            },
            {
                "product":"03",
                "testType":"rawMaterial",
                "testName":"桂圓四物飲-原料1",
                "rawMaterialTestName":"01",
                "testItems":[{testItem:"01"},{testItem:"03", details:["0301","0303"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"原料1製造商",
                "originPlace":"美國",
                "testResult":"unqualified",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-09-13T08:20:10.000Z",
                "lotNo":"2018007",
                "model":"HFT-40"
            }
        ],
    },
]

export default assessmentReviews;